import CryptoJS from 'crypto-js';
import _$1 from 'lodash';
import Papa from 'papaparse';
import moment$1 from 'moment-msdate';
import { compile } from 'path-to-regexp';
import URI from 'urijs';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

var ms = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = ms;
	createDebug.destroy = destroy;

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;
		let enableOverride = null;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return '%';
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.useColors = createDebug.useColors();
		debug.color = createDebug.selectColor(namespace);
		debug.extend = extend;
		debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

		Object.defineProperty(debug, 'enabled', {
			enumerable: true,
			configurable: false,
			get: () => enableOverride === null ? createDebug.enabled(namespace) : enableOverride,
			set: v => {
				enableOverride = v;
			}
		});

		// Env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		return debug;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);

		createDebug.names = [];
		createDebug.skips = [];

		let i;
		const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		const len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names.map(toNamespace),
			...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		let i;
		let len;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/
	function toNamespace(regexp) {
		return regexp.toString()
			.substring(2, regexp.toString().length - 2)
			.replace(/\.\*\?$/, '*');
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	/**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/
	function destroy() {
		console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

var common = setup;

var browser = createCommonjsModule(function (module, exports) {
/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */

exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (() => {
	let warned = false;

	return () => {
		if (!warned) {
			warned = true;
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}
	};
})();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */
exports.log = console.debug || console.log || (() => {});

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = common(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};
});

const debug = browser('util:security');
const encrypt = function (data, secret) {
  debug('Encrypt params: ', data, secret);

  try {
    const cipherText = CryptoJS.AES.encrypt(data, secret).toString();
    return cipherText;
  } catch (e) {
    debug('Error in encrypt', e);
    return 'Error encrypting data.';
  }
};
const decrypt = function (cipherText, secret) {
  debug('Decrypt params: ', cipherText, secret);

  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, secret);
    debug('Check bytes', bytes);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  } catch (e) {
    debug('Error in decrypt', e);
    return 'Error decrypting data.';
  }
};
const checkIfEncrypted = function (cipherText, secret) {
  debug('Check params: ', cipherText, secret);

  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, secret);
    debug('Check bytes', bytes);
    const {
      sigBytes
    } = bytes;

    if (sigBytes < 0) {
      return false;
    }

    return true;
  } catch (e) {
    debug('Error in check', e);
    return false;
  }
};

const getType = function (obj) {
  return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
};
function isEmptyValues(value) {
  return value === undefined || value === null || typeof value === 'number' && isNaN(value) || typeof value === 'string' && value.trim().length() === 0;
}

var moment = createCommonjsModule(function (module, exports) {
(function (global, factory) {
     module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
});

function sorter(a, b) {
  const l = Math.max(a.length, b.length);

  for (let i = 0; i < l; i += 1) {
    if (!(i in a)) return -1;
    if (!(i in b)) return +1;
    if (a[i].toUpperCase() > b[i].toUpperCase()) return +1;
    if (a[i].toUpperCase() < b[i].toUpperCase()) return -1;
    if (a.length < b.length) return -1;
    if (a.length > b.length) return +1;
  }
}

function pathsort(paths, sep) {
  sep = sep || '/';
  return paths.map(function (el) {
    return el.split(sep);
  }).sort(sorter).map(function (el) {
    return el.join(sep);
  });
}

function addToTree(node, treeNodes) {
  // Check if the item node should inserted in a subnode
  for (let i = 0; i < treeNodes.length; i++) {
    const treeNode = treeNodes[i]; // "/store/travel".indexOf( '/store/' )

    if (node.slug.indexOf(`${treeNode.slug}`) == 0) {
      addToTree(node, treeNode.children); // Item node was added, we can quit

      return;
    }
  } // Item node was not added to a subnode, so it's a sibling of these treeNodes


  treeNodes.push({
    title: node.title,
    slug: node.slug,
    route: node.route,
    order: node.order,
    children: []
  });
}
/**
 * Creates Ant Design specific tree for Menu consumption
 * @param {Array} nodes Array of nodes to create tree
 */

function createTree(nodes) {
  const navPaths = nodes.map(node => node.slug);
  const sortedNavPaths = pathsort(navPaths);
  const tree = [];
  sortedNavPaths.map(slug => {
    const node = nodes.find(n => n.slug === slug);
    addToTree(node, tree);
  });

  const orderedTree = _$1.orderBy(tree, [({
    order
  }) => order, ['asc']]);

  return orderedTree;
}

const arrayToObject = function (key, input) {
  return _$1.reduce(input, (acc, value) => {
    acc.push({
      [key]: value
    });
    return acc;
  }, []);
};
const sanitizeMatrix = function (input) {
  if (_$1.isArray(input)) {
    // flatten deep
    return _$1.flattenDeep(input);
  }

  return _$1.flattenDeep(input.split(','));
};
const asyncBatchProcess = async (array, fn, parallel, fnArgs = {}) => {
  const parallelBatches = Math.ceil(array.length / parallel);
  console.log(`\nI have gotten the task of ${array.length} and will take ${parallel} of them in parallel.`);
  console.log(` This will result in ${parallelBatches} batches.`); // Split up the Array

  let k = 0;
  const allValues = [];

  for (let i = 0; i < array.length; i += parallel) {
    k++;
    console.log(`\nBatch ${k} of ${parallelBatches}`); // Launch and Setup Chromium

    const promises = [];

    for (let j = 0; j < parallel; j++) {
      const elem = i + j; // only proceed if there is an element

      if (array[elem] != undefined) {
        // Promise to take Screenshots
        promises.push(fn(array[elem], fnArgs));
      }
    } // await promise all and close browser


    await Promise.all(promises).then(function (values) {
      console.log("\nI finished this batch. I'm ready for the next batch"); // console.log(values);

      allValues.push(...values);
    });
  }

  return allValues;
};
const batchProcess = async (array, fn, parallel) => {
  const parallelBatches = Math.ceil(array.length / parallel);
  console.log(`\nI have gotten the task of ${array.length} and will take ${parallel} of them in parallel.`);
  console.log(` This will result in ${parallelBatches} batches.`); // Split up the Array

  let k = 0;

  for (let i = 0; i < array.length; i += parallel) {
    k++;
    console.log(`\nBatch ${k} of ${parallelBatches}`); // Launch and Setup Chromium

    const functions = [];

    for (let j = 0; j < parallel; j++) {
      const elem = i + j; // only proceed if there is an element

      if (array[elem] != undefined) {
        // Promise to take Screenshots
        functions.push(fn);
      }
    } // await promise all and close browser


    functions.forEach(func => func());
    console.log("\nI finished this batch. I'm ready for the next batch");
    const delayInMilliseconds = 1000; // 1 second

    setTimeout(function () {// your code to be executed after 1 second
    }, delayInMilliseconds);
  }
};
const sortingComparators = (field, config = {}) => ({
  date: (a, b) => {
    if (config.dateFormat) {
      const {
        dateFormat
      } = config;
      return moment(a[field], dateFormat) - moment(b[field], dateFormat);
    }

    return moment(a[field]) - moment(b[field]);
  },
  number: (a, b) => a[field] - b[field],
  money: (a, b) => a[field] - b[field],
  digit: (a, b) => a[field] - b[field],
  index: (a, b) => a[field] - b[field],
  indexBorder: (a, b) => a[field] - b[field],
  string: (a, b) => {
    const isNonSortable = item => _$1.isNil(item) || item === '';

    if (isNonSortable(a[field]) && isNonSortable(b[field])) {
      return 0;
    }

    if (isNonSortable(a[field])) {
      return 1;
    }

    if (isNonSortable(b[field])) {
      return -1;
    }

    const x = a[field].toUpperCase();
    const y = b[field].toUpperCase();
    return x == y ? 0 : x > y ? 1 : -1;
  },
  text: (a, b) => {
    const isNonSortable = item => _$1.isNil(item) || item === '';

    if (isNonSortable(a[field]) && isNonSortable(b[field])) {
      return 0;
    }

    if (isNonSortable(a[field])) {
      return 1;
    }

    if (isNonSortable(b[field])) {
      return -1;
    }

    const x = a[field].toUpperCase();
    const y = b[field].toUpperCase();
    return x == y ? 0 : x > y ? 1 : -1;
  },
  default: (a, b) => a[field] - b[field]
});
const sequenceArrayToObject = array => array.reduce((acc, param, index) => {
  if (index % 2 === 0) {
    acc[param] = null;
    return acc;
  }

  const paramName = array[index - 1];
  acc[paramName] = param;
  return acc;
}, {});

function sanitizeParameters(parameters) {
  const one = _$1.map(parameters, param => {
    if (_$1.isNil(param.required)) {
      param.required = false;
    }

    return param;
  });

  return _$1.orderBy(one, ['required'], ['desc']);
}

function objectToExcelParams(parameters = {}) {
  const compiled = _$1.reduce(parameters, function (result, value, key) {
    const string = `"${key}","${value}"`;
    result.push(string);
    return result;
  }, []);

  if (!_$1.isEmpty(compiled)) {
    return `{${compiled.join(';')}}`;
  }

  return compiled.join(';');
}

function functionBuilder(providerName, resourceName, parameters, host = 'web') {
  const namespace = host === 'sheets' ? `CSQUERY` : `CS.QUERY`;

  try {
    if (_$1.isEmpty(parameters)) {
      return `=${namespace}("${providerName}", "${resourceName}")`;
    }

    const parsedParameters = objectToExcelParams(parameters);
    return `=${namespace}("${providerName}", "${resourceName}", ${parsedParameters})`;
  } catch (e) {
    console.info(e);
    return `=${namespace}("${providerName}", "${resourceName}")`;
  }
}

async function generateFunction(data, environment) {
  const {
    parameters,
    provider
  } = data;
  const {
    name: providerName
  } = provider;
  const sanitized = sanitizeParameters(parameters);
  const toSend = sanitized.reduce((acc, param) => {
    const {
      name,
      default: defaultValue
    } = param;
    acc[name] = defaultValue;
    return acc;
  }, {});
  return functionBuilder(providerName, data.name, toSend, environment);
}
/**
 * Generates different stubs from source data. Types include custom function stubs, web stubs, etc.
 * @param {string} type excel, google, or web
 * @param {object} data data to generate stub
 */


async function generateStub({
  type,
  data
}) {
  switch (type) {
    case 'excel':
      return generateFunction(data, 'excel');

    case 'sheets':
      return generateFunction(data, 'sheets');

    default:
      return 'No type specified. Exiting.';
  }
}

/**
 * Creates link source and filename from template
 * @param  {string} base64 Base64 encoded file string for Excel template
 * @param  {string} name What the filename of the output will be
 * @return {void}
 */

function downloadExcelFromWeb(base64, name) {
  const friendlyTemplate = window.decodeURI(base64);
  const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${friendlyTemplate}`;
  const downloadLink = document.createElement('a');
  const fileName = `${_$1.snakeCase(name)}`;
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}

async function determineHost() {
  let host;

  if (typeof window === 'undefined') {
    host = null;
  } else {
    host = window.location.href;
  }

  try {
    if (host.includes('google')) {
      return 'sheets';
    }

    if (window && window.Office) {
      const data = await window.Office.onReady();

      if (data.host === 'Excel') {
        return 'excel';
      }
    }

    return 'web';
  } catch (e) {
    return 'web';
  }
}

const debug$1 = browser('util:build-symbol-id');
/**
 * Builds separate pieces of symbol id into full symbol id (BITFINEX_SPOT_BTC_USD)
 * @param {object} parts exchange, type, base, quote, futureDeliveryTime, optionExpirationTime, optionStrikePrice, optionType
 */

function buildSymbolId(parts) {
  const sanitizedParts = _$1.mapValues(parts, (val, key) => {
    if (_$1.isNil(val) || val === '') {
      val = undefined;
      return val;
    }

    const string = _$1.toString(val);

    const value = _$1.toUpper(string);

    return value;
  });

  const {
    exchange = 'BINANCE',
    type = 'SPOT',
    base = 'BTC',
    quote = 'USD',
    futureDeliveryTime,
    optionExpirationTime,
    optionStrikePrice,
    optionType,
    indexId
  } = sanitizedParts;
  debug$1('Type ===> ', {
    exchange,
    type,
    base,
    quote
  });
  const SPOT = `${exchange}_SPOT_${base}_${quote}`;
  const FUTURES = `${exchange}_FTS_${base}_${quote}_${futureDeliveryTime}`;
  const OPTION = `${exchange}_OPT_${base}_${quote}_${optionExpirationTime}_${optionStrikePrice}_${optionType}`;
  const PERPETUAL = `${exchange}_PERP_${base}_${quote}`;
  const INDEX = `${exchange}_IDX_${indexId}`;
  const CREDIT = `${exchange}_CRE_${base}`;
  const DEFAULT = `BITFINEX_SPOT_BTC_USD`;
  debug$1('Credit ==> ', CREDIT);

  switch (type) {
    case 'SPOT':
      return SPOT;

    case 'FUTURES':
    case 'FTS':
      return FUTURES;

    case 'OPT':
    case 'OPTION':
      return OPTION;

    case 'PERP':
    case 'PERPETUAL':
      return PERPETUAL;

    case 'INDEX':
    case 'IDX':
      return INDEX;

    case 'CREDIT':
    case 'CRD':
      return CREDIT;

    default:
      return DEFAULT;
  }
}

/**
 * Executes a shell command and return it as a Promise.
 * @param cmd {string}
 * @return {Promise<string>}
 */
const execShellCommand = function (cmd) {// const { exec } = require('child_process');
  // return new Promise((resolve, reject) => {
  //   exec(cmd, (error, stdout, stderr) => {
  //     if (error) {
  //       console.warn(error);
  //     }
  //     resolve(stdout || stderr);
  //   });
  // });
};

function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

function parseName(input) {
  const fullName = input || '';
  const result = {};

  if (fullName.length > 0) {
    const nameTokens = fullName.match(/[A-ZÁ-ÚÑÜ][a-zá-úñü]+|([aeodlsz]+\s+)+[A-ZÁ-ÚÑÜ][a-zá-úñü]+/g) || [];

    if (nameTokens.length > 3) {
      result.firstName = nameTokens.slice(0, 2).join(' ');
    } else {
      result.firstName = nameTokens.slice(0, 1).join(' ');
    }

    if (nameTokens.length > 2) {
      result.lastName = nameTokens.slice(-2, -1).join(' ');
      result.secondLastName = nameTokens.slice(-1).join(' ');
    } else {
      result.lastName = nameTokens.slice(-1).join(' ');
      result.secondLastName = '';
    }
  }

  return result;
}

const titlecase = input => input[0].toLocaleUpperCase() + input.slice(1);

function pascalCase(value) {
  if (value === null || value === void 0) return '';
  if (typeof value.toString !== 'function') return '';
  const input = value.toString().trim();
  if (input === '') return '';
  if (input.length === 1) return input.toLocaleUpperCase();
  const match = input.match(/[a-zA-Z0-9]+/g);

  if (match) {
    return match.map(m => titlecase(m)).join('');
  }

  return input;
}

function unicornCase(str) {
  str = _$1.toLower(str);
  let newStr = '';

  for (let i = 0; i < str.length; i++) {
    const char = str.charAt(i);

    if (char === '>') {
      newStr = newStr.concat('gt');
    } else if (char === '<') {
      newStr = newStr.concat('lt');
    } else if (char === ' ') {
      newStr = newStr.concat('-');
    } else {
      newStr = newStr.concat(char);
    }
  }

  return newStr;
}

function dig(obj, target) {
  return target in obj ? obj[target] : Object.values(obj).reduce((acc, val) => {
    if (acc !== undefined) return acc;
    if (typeof val === 'object') return dig(val, target);
  }, undefined);
}

const log = browser('@cryptosheets/util:sanitize-object-in-array');
const uniqueKey = '__'; // Returns all unique values of an array.

const extractUniquePropertiesAndValues = obj => _$1.reduce(Object.keys(obj), function (result, property) {
  // Step 1: split property by unique delimiter
  const split = property.split(uniqueKey);

  const targetValue = _$1.last(split);

  if (_$1.size(split) === 1) {
    // Key and value had no delimiter, but should still be included
    if (!result.targetValues.includes(targetValue)) {
      result.targets.push(targetValue);
      result.targetValues.push('');
    }

    return result;
  }

  const target = _$1.initial(split).join(uniqueKey);

  if (!result.targets.includes(target)) {
    result.targets.push(target);
  }

  if (!result.targetValues.includes(targetValue)) {
    result.targetValues.push(targetValue);
  }

  return result;
}, {
  targets: [],
  targetValues: []
});

function transposeObject(data) {
  return Object.keys(data).map(key => ({
    target: key,
    value: data[key]
  }));
}
/**
 * Will turn a mixed object inside of an array into a flattened collection, or transpose an object
 * that does not contain the delimiter specified
 * @param {array} array Javascript array that contains huge object
 */


function sanitizeObjectIntoCollection(object) {
  log('Object to sanitize ', object);
  const {
    targets,
    targetValues
  } = extractUniquePropertiesAndValues(object);
  log('Unique properties ', {
    targets,
    targetValues
  }); // If unique properties is [''], then it means the object had no nesting

  if (_$1.isEqual(targets, Object.keys(object))) {
    return transposeObject(object);
  } // For all targets, we look for combined target + target value in main object


  try {
    return _$1.reduce(targets, function (result, target) {
      const obj = {
        target
      };
      targetValues.forEach(targetValue => {
        const combined = [target, targetValue].join(uniqueKey);
        log('Combined: ', combined);

        if (_$1.has(object, combined)) {
          // combination exists, add to obj
          obj[targetValue] = object[combined];
        }
      });
      result.push(obj);
      return result;
    }, []);
  } catch (e) {
    return object;
  }
}

const isDate = d => d instanceof Date && !isNaN(d);

const jsonFlatten = function (data, delimiter = '.') {
  const result = {};

  function recurse(cur, prop) {
    if (Object(cur) !== cur) {
      result[prop] = cur;
    } else if (Array.isArray(cur)) {
      for (var i = 0, l = cur.length; i < l; i++) recurse(cur[i], prop ? `${prop}${delimiter}${i}` : `${i}`);

      if (l == 0) result[prop] = [];
    } else if (isDate(cur)) {
      result[prop] = cur.toString();
    } else {
      let isEmpty = true;

      for (const p in cur) {
        isEmpty = false;
        recurse(cur[p], prop ? `${prop}${delimiter}${p}` : p);
      }

      if (isEmpty) result[prop] = {};
    }
  }

  recurse(data, '');
  return result;
};

/* eslint-disable eqeqeq */
const log$1 = browser('@cryptosheets/util:flatten-object');
const uniqueKey$1 = '__';

const isObject = val => val === null ? false : Array.isArray(val) ? false : typeof val === 'function' || typeof val === 'object';

const isPrim = val => {
  const type = typeof val;
  return !!(type === 'number' || type === 'string' || type === 'boolean' || type == 'null');
};

const isArray = val => Array.isArray(val); // Find the first array in an object, otherwise turn object into array


const arrayFrom = json => {
  const queue = [];
  let next = json;

  while (next !== undefined) {
    if (isArray(next)) {
      if (next.length > 0) {
        if (!isPrim(next[0])) {
          return next;
        }
      }
    }

    if (isObject(next)) {
      for (const key in next) {
        queue.push(next[key]);
      }
    }

    next = queue.shift();
  } // nothing found, consider the whole object a row


  return [json];
}; // Get size of arrays, objects or strings.


const size = val => Array.isArray(val) ? val.length : val && typeof val === 'object' ? val.size || val.length || Object.keys(val).length : typeof val === 'string' ? new Blob([val]).size : 0; // 1. Find the primary array to iterate over
// 2. For each item in the array, recursively flatten it into tabular object
// 3. Turn tabular object into a csv row (use a library for this)


const flattenObject = json => {
  try {
    const inArray = arrayFrom(json);
    log$1('Completed in Array');
    const outArray = [];

    for (const row in inArray) {
      outArray[outArray.length] = jsonFlatten(inArray[row], uniqueKey$1);
    }

    log$1('Out Array before clean', outArray);
    const arraySize = size(outArray);
    log$1('Size of array', arraySize); // Now we check if the json had a bad parse
    // If array is less than 2, it may contain a huge object

    if (arraySize < 2) {
      // Check size of the resulting object
      const objSize = size(outArray[0]);

      if (objSize > 25) {
        try {
          const modifiedArray = sanitizeObjectIntoCollection(outArray[0]);
          return flattenObject(modifiedArray);
        } catch (e) {
          return outArray;
        }
      }
    }

    log$1('Out Array after clean', outArray);
    return outArray;
  } catch (e) {
    log$1('Error: ', e);
    return json;
  }
};

const debug$2 = browser('@cryptosheets/util/collections/parse-to-2d-array');

function argsToOrderBy(sort) {
  // Split string to get sort arguments
  const splitSort = sort.split(',');
  const fieldList = [];
  const fieldOrders = [];
  splitSort.map(str => {
    if (_$1.startsWith(str, '-')) {
      fieldList.push(str.substring(1)); // Strings starts with -, delineates descending order

      fieldOrders.push('desc');
    } else {
      fieldList.push(str);
      fieldOrders.push('asc');
    }
  });
  return {
    fieldList,
    fieldOrders
  };
}

function parseJSONto2dArray(response, args) {
  // First we sanitize arguments
  const sanitizedArgs = _$1.omitBy(args, val => _$1.isNil(val) || val === '');

  const {
    fields,
    limit,
    sort
  } = sanitizedArgs || {};
  let obj;
  const data = response;
  const readyJson = flattenObject(data);
  debug$2('flatten object ', readyJson);

  if (sort && sort !== 0) {
    const {
      fieldList,
      fieldOrders
    } = argsToOrderBy(sort);
    obj = _$1.orderBy(obj, fieldList, fieldOrders);
  }

  if (fields) {
    const splitFieldsIntoArray = fields.split(',');
    obj = {
      fields: splitFieldsIntoArray,
      data: readyJson
    };
  } else {
    obj = readyJson;
  }

  const unparse = Papa.unparse(obj);
  const parsed = Papa.parse(unparse, {
    dynamicTyping: true,
    preview: limit
  });
  return parsed.data;
}

function getAllKeys(collection) {
  return _$1.reduce(collection, (acc, item) => {
    _$1.keys(item).forEach(key => {
      if (acc.indexOf(key) === -1) {
        acc.push(key);
      }
    });

    return acc;
  }, []);
}

function jsonToCSV(input) {
  if (!input) {
    return 'Please enter a valid JSON string to convert to CSV.';
  }

  const readyJson = flattenObject(input); // Papa parse only gets headers from first object, so we must sort by length of object
  // const sortedJson = _.orderBy(readyJson, item => Object.keys(item).length, [
  //   'desc',
  // ]);

  const csv = Papa.unparse(readyJson, {
    columns: getAllKeys(readyJson)
  });
  return csv;
}

function is2dArray(array) {
  if (array[0] === undefined) {
    return false;
  }

  return array[0].constructor === Array;
}

function jsonTo2dArray(input) {
  if (!input) {
    return 'Please enter a valid JSON string to convert to CSV.';
  }

  if (is2dArray(input)) {
    return input;
  }

  const csv = jsonToCSV(input);
  const result = Papa.parse(csv, {
    dynamicTyping: true
  }).data; // const result = Papa.parse(csv).data;

  return result;
} // const result = [

const jsonUnflatten = function (data, delimiter = '.') {
  if (Object(data) !== data || Array.isArray(data)) return data;
  const result = {};
  let cur;
  let prop;
  let idx;
  let last;
  let temp;

  for (const p in data) {
    cur = result, prop = '', last = 0;

    do {
      idx = p.indexOf(delimiter, last);
      temp = p.substring(last, idx !== -1 ? idx : undefined);
      cur = cur[prop] || (cur[prop] = !isNaN(parseInt(temp)) ? [] : {});
      prop = temp;
      last = idx + 1;
    } while (idx >= 0);

    cur[prop] = data[p];
  }

  return result[''];
};

/**
 * Converts an Excel timestamp into a Date or moment readable string
 * @param {string} excelTimestamp Microsoft Excel specific timestamp
 */
const parseDateExcel = excelTimestamp => {
  if (excelTimestamp === '') {
    return null;
  }

  const secondsInDay = 24 * 60 * 60;
  const excelEpoch = new Date(1899, 11, 31);
  const excelEpochAsUnixTimestamp = excelEpoch.getTime();
  const missingLeapYearDay = secondsInDay * 1000;
  const delta = excelEpochAsUnixTimestamp - missingLeapYearDay;
  const excelTimestampAsUnixTimestamp = excelTimestamp * secondsInDay * 1000;
  const parsed = excelTimestampAsUnixTimestamp + delta;
  return isNaN(parsed) ? null : parsed;
};

function isExcelDate(date) {
  try {
    const momentDate = moment$1.fromOADate(date);
    return momentDate.isValid();
  } catch (e) {
    return false;
  }
}

function isCorrectFormat(date) {
  try {
    const momentDate = moment$1(date);
    return momentDate.isValid();
  } catch (e) {
    return false;
  }
}

function nilOrDate(date) {
  if (_$1.isNil(date) || date === '' || date === 0) {
    return null;
  }

  if (_$1.isDate(date)) {
    return date;
  }

  if (isExcelDate(date)) {
    return moment$1(new Date(parseDateExcel(date))).format();
  }

  if (isCorrectFormat(date)) {
    return moment$1(date).format();
  }

  return null;
}

function toExcelDate(dateString) {
  const date = moment$1(dateString);
  return date.toOADate();
}
function fromExcelDate(excelTimestamp) {
  const date = moment$1(excelTimestamp);
  return date.fromOADate();
}

/**
 * Calculates shape of data from JSON response, and places data into worksheet
 * @param {object} data 2d Array calculated from parse function
 * @param {*} path Calculated path object from Excel
 */
const placeData = (data, path) => {
  const {
    row,
    col,
    worksheet
  } = path;
  const lastRow = row + (data.length - 1);
  const lastCol = col + (data[0].length - 1);
  const firstCell = worksheet.getCell(row, col);
  const lastCell = worksheet.getCell(lastRow, lastCol);
  const range = firstCell.getBoundingRect(lastCell).insert('down');
  range.values = data;
  range.format.font.bold = false;
  range.format.autofitColumns();
};

const setData = async response => {
  await window.Excel.run(async context => {
    // const range = await getRange();
    const myWorkbook = context.workbook;
    const activeCell = myWorkbook.getActiveCell();
    activeCell.load(['address', 'rowIndex', 'columnIndex', 'worksheet']);
    return context.sync().then(() => {
      const {
        rowIndex,
        columnIndex,
        worksheet
      } = activeCell;
      const path = {
        row: rowIndex,
        col: columnIndex,
        worksheet
      };
      placeData(response, path);
    });
  });
};

function setDataGoogle(data) {
  return window.google.script.run.withSuccessHandler(sheetData => 'ok').withFailureHandler(sheetError => window.google.script.run.failedData()).setData(data);
}

function addNewWorksheetWithData(data) {
  return window.google.script.run.withSuccessHandler(sheetData => 'ok').withFailureHandler(sheetError => window.google.script.run.failedData()).addSheetWithData(data);
}

async function verifyExcel() {
  const office = await window.Office.onReady();

  if (office.host === null) {
    return false;
  }

  return true;
}

function verifyGoogle() {
  const {
    host
  } = window.location;

  if (host.includes('google')) {
    return true;
  }

  return false;
}

async function parseThenSendToSheet(data) {
  const isGoogle = verifyGoogle();

  if (isGoogle) {
    try {
      const parsedData = jsonTo2dArray(data);
      return setDataGoogle(parsedData);
    } catch (e) {
      console.info('Failed sending to google. Reason: ', e);
      return {};
    }
  }

  try {
    const isOffice = await verifyExcel();

    if (isOffice) {
      const parsedData = parseJSONto2dArray(data);
      return setData(parsedData);
    }
  } catch (e) {
    return e;
  }
}

async function verifyExcel$1() {
  try {
    await window.Office.onReady();
  } catch (error) {
    console.log('Office failed to initialize');
  }
}
/** Default helper for invoking an action and handling errors. */


async function tryCatch(callback) {
  try {
    await verifyExcel$1();
    await callback();
  } catch (error) {
    // Note: In a production add-in, you'd want to notify the user through your add-in's UI.
    console.error(error); // return error;
  }
}

/**
 * Function retrieves a cached token or opens a dialog box if there is no saved token. Note that this is not a sufficient example of authentication but is intended to show the capabilities of the Dialog object.
 * @param {string} url URL for a stored token.
 */
function getTokenViaDialog(url) {
  let _dialogOpen;

  let _cachedToken;

  return new Promise(function (resolve, reject) {
    if (_dialogOpen) {
      // Can only have one dialog box open at once, wait for previous dialog box's token
      const timeout = 5;
      let count = 0;
      const intervalId = setInterval(function () {
        count++;

        if (_cachedToken) {
          resolve(_cachedToken);
          clearInterval(intervalId);
        }

        if (count >= timeout) {
          reject('Timeout while waiting for token');
          clearInterval(intervalId);
        }
      }, 1000);
    } else {
      _dialogOpen = true;
      window.OfficeRuntime.displayWebDialog(url, {
        height: '50%',
        width: '50%',

        onMessage(message, dialog) {
          _cachedToken = message;
          resolve(message);
          dialog.close();
        },

        onRuntimeError(error, dialog) {
          reject(error);
        }

      }).catch(function (e) {
        reject(e);
      });
    }
  });
}

function getExcel(callback) {
  try {
    return window.Excel.run(callback);
  } catch (e) {
    console.log('Unable to get excel instance, Error: ', e);
  }
}

var Excel = {
  run: callback => getExcel(callback)
};

async function hideGridlines() {
  await Excel.run(async context => {
    const sheet = context.workbook.worksheets.getActiveWorksheet();
    sheet.showGridlines = false;
    await context.sync();
  });
}

async function writeData(sheet, sheetData) {
  const {
    title,
    headerNames,
    data,
    resource
  } = sheetData; // Set the report title

  const titleCell = sheet.getCell(0, 0);
  titleCell.values = [title];
  titleCell.format.font.name = 'Arial';
  titleCell.format.font.size = 18;
  const headerRow = titleCell.getOffsetRange(1, 0).getResizedRange(0, headerNames.length - 1);
  headerRow.values = [headerNames];
  headerRow.getRow(0).format.font.bold = true;
  headerRow.format.fill.color = '#4473c5';
  headerRow.format.font.color = 'white';
  const dataRange = headerRow.getOffsetRange(1, 0).getResizedRange(data.length - 1, 0);

  if (!_$1.isEmpty(data)) {
    dataRange.values = data;
  }

  dataRange.getColumn(1).style = 'input';
  dataRange.getCell(0, 2).style = 'Calculation';
  dataRange.getCell(1, 2).style = 'Calculation'; // dataRange.getColumn(2).style = 'Calculation';

  titleCell.getResizedRange(0, headerNames.length - 1).merge();
  dataRange.format.autofitColumns();
  const resourceRange = sheet.getRange('C4');
  resourceRange.values = [[resource]];
  await sheet.context.sync();
}
/** Load sample data into a new worksheet and create a chart */


async function createReport(data, config) {
  await Excel.run(async context => {
    const sheet = context.workbook.worksheets.add();

    try {
      await writeData(sheet, data);
      sheet.activate();
      await context.sync();
      await hideGridlines();
    } catch (error) {
      // Try to activate the new sheet regardless, to show
      // how far the processing got before failing
      sheet.activate();
      await context.sync();
      await hideGridlines(); // Then re-throw the original error, for appropriate error-handling
      // (in this snippet, simply showing a notification)

      throw error;
    }
  });
}

/* eslint-disable func-names */
const ex = {};
const Excel$1 = typeof window === 'undefined' ? ex : window.Excel;
async function verifyExcel$2() {
  const office = await window.Office.onReady();

  if (office.host === null) {
    return false;
  }

  return true;
}
function errorHandler(err) {
  console.log(err);
}
async function getActiveCellAddress() {
  await Excel$1.run(async context => {
    const myWorkbook = context.workbook;
    const activeCell = myWorkbook.getActiveCell();
    activeCell.load('address');
    await context.sync();
    console.log(`The active cell is ${activeCell.address}`);
    return activeCell.address;
  });
}
async function getActiveCellValues() {
  await Excel$1.run(async context => {
    const myWorkbook = context.workbook;
    const activeCell = myWorkbook.getActiveCell();
    activeCell.load('values');
    await context.sync();
    console.log(`The active cell values are ${activeCell.values}`);
    return activeCell.values;
  });
}
async function onSelectionChange(event) {
  await Excel$1.run(async context => {
    console.log(`The selected range has changed to: ${event.address}`);
    return getActiveCellValues();
  });
}
async function registerSelectionChangedHandler(cb) {
  await window.Excel.run(async context => {
    const sheet = context.workbook.worksheets.getActiveWorksheet();
    sheet.onSelectionChanged.add(cb);
    await context.sync();
  });
}
async function selectRange() {
  await Excel$1.run(async context => {
    const sheet = context.workbook.worksheets.getActiveWorksheet();
    const range = sheet.getRange('B7:C7');
    range.select();
    await context.sync();
  });
}
function sendTokenToCustomFunction(key, token) {
  return window.OfficeRuntime.storage.setItem(key, token).then(function () {
    console.log(`Success: Item with key '${key}' saved to Storage.`);
  }, function (error) {
    console.log(`Error: Unable to save item with key '${key}' to Storage. ${error}`);
  });
}
async function getTokenFromCustomFunction(key) {
  console.log('Running get token function');
  const isOffice = await verifyExcel$2();

  if (isOffice) {
    return window.OfficeRuntime.storage.getItem(key).then(function (result) {
      return result;
    }, function (error) {
      console.log(`Error: Unable to read item with key '${key}' from Storage. ${error}`);
    });
  }
}
//   errorHandler,
//   getActiveCellAddress,
//   getActiveCellValues,
//   onSelectionChange,
//   registerSelectionChangedHandler,
//   selectRange,
//   tryCatch,
//   sendTokenToCustomFunction,
//   getTokenFromCustomFunction,
// };

async function copyCurrentWorksheet() {
  const {
    Excel
  } = window;
  await Excel.run(async context => {
    const myWorkbook = context.workbook;
    const sampleSheet = myWorkbook.worksheets.getActiveWorksheet();
    console.log(sampleSheet);
  });
}
async function getActiveWorksheet() {
  const worksheetName = await window.Excel.run(async context => {
    const sheet = context.workbook.worksheets.getActiveWorksheet();
    sheet.load('name');
    await context.sync();
    console.log(`The active worksheet is "${sheet.name}"`);
    return sheet.name;
  });
  return worksheetName;
}
/**
 * Deletes all worksheets in an Excel worksheet besides the passed in tabName
 * @param {string} tabName Name of tab in worksheet you want to keep
 */

async function stripWorksheet(tabName) {
  await window.Excel.run(async context => {
    // const worksheet = context.workbook.worksheets.getItem(tabName);
    try {
      const {
        worksheets
      } = context.workbook;
      worksheets.load('items/name');
      await context.sync();
      const {
        items
      } = worksheets;
      items.map(worksheet => {
        if (worksheet.name !== tabName) {
          const worksheetToDelete = context.workbook.worksheets.getItem(worksheet.name);
          worksheetToDelete.delete();
          console.log('deleting ', worksheet);
        }

        return context.sync();
      });
      await context.sync();
    } catch (e) {
      console.log(e);
    }
  });
}
/**
 * Insert workbook contents from base64 encoded string at the end of current workbook.
 * @param {*} workbookContents base64 encoded template string
 */

async function insertSheets(workbookContents, sheetNamesToInsert = []) {
  return window.Excel.run(context => {
    const sheets = context.workbook.worksheets;
    sheets.addFromBase64(workbookContents, sheetNamesToInsert, // get all the worksheets
    window.Excel.WorksheetPositionType.end // insert them after the current workbook's worksheets
    );
    return context.sync();
  });
}
/**
 * Creates a new workbook from a base64 encoded string
 * @param {string} fileContents base64 encoded string
 * @param {string} tab Tab name of file to include
 * @param {string} host Environment host, ie 'web', 'excel', 'sheets'
 */

async function newWorkbookFromEncodedString(fileContents, tab, host = 'excel') {
  if (host === 'web' || host === 'sheets') {
    return downloadExcelFromWeb(fileContents, 'download');
  }

  await window.Excel.run(async context => {
    try {
      await window.Excel.createWorkbook(fileContents);
      await context.sync();
      const {
        workbook
      } = context;
      workbook.load('name');
      await context.sync();
      console.log(workbook.name);
    } catch (e) {
      console.error(e);
    }
  });
}
function getFileContents(file, onSuccess, onError, maxFileSize) {
  const {
    Office
  } = window;
  const expectedSliceCount = file.sliceCount;
  const fileSlices = [];
  console.log(`Current file size in bytes: ${file.size}`);

  if (file.size > maxFileSize) {
    return onError('current file is too big. File size: ', file.size);
  }

  console.log(`Number of file slices: ${file.sliceCount}`);

  function getFileContentsHelper() {
    file.getSliceAsync(fileSlices.length, function (result) {
      if (result.status === Office.AsyncResultStatus.Failed) {
        file.closeAsync();
        return onError(result.error);
      } // Got one slice, store it in a temporary array.


      fileSlices.push(result.value.data);

      if (fileSlices.length == expectedSliceCount) {
        console.log('All slices have been received.');
        file.closeAsync();
        let array = [];
        fileSlices.forEach(slice => {
          array = array.concat(slice);
        });
        onSuccess(array);
      } else {
        getFileContentsHelper();
      }
    });
  }

  getFileContentsHelper();
}
/**
 * Returns current Office document into byteArray
 * @param {*} onSuccess Returns byteArray to convert into base64
 * @param {*} onError Error handler function
 */

function getCurrentFile(onSuccess, onError, maxFileSize) {
  const {
    Office
  } = window;
  const sliceSize = 4096;
  /* Bytes */
  // This snippet specifies a small slice size to show how the getFileAsync() method uses slices.

  Office.context.document.getFileAsync(Office.FileType.Compressed, {
    sliceSize
  }, function (result) {
    if (result.status === Office.AsyncResultStatus.Failed) {
      return onError(result.error);
    } // Result.value is the File object.


    getFileContents(result.value, onSuccess, onError, maxFileSize);
  });
}
async function getFileAsPDF() {
  const {
    Office
  } = window; // The following example gets the document in PDF format.

  Office.context.document.getFileAsync(Office.FileType.Pdf, function (result) {
    if (result.status == 'succeeded') {
      const myFile = result.value;
      const {
        sliceCount
      } = myFile;
      console.log(`File size:${myFile.size} #Slices: ${sliceCount}`); // Now, you can call getSliceAsync to download the files,
      // as described in the previous code segment (compressed format).

      myFile.closeAsync();
    } else {
      console.log(result.error.message);
    }
  });
} // export default {
//   copyCurrentWorksheet,
//   getActiveWorksheet,
//   stripWorksheet,
//   insertSheets,
//   newWorkbookFromEncodedString,
//   getFileContents,
//   getCurrentFile,
//   getFileAsPDF,
// };

function ensureFile(filePath, fs) {
  try {
    if (fs.existsSync(filePath)) {
      // File exists, read it
      const rawData = fs.readFileSync(filePath);
      return JSON.parse(rawData);
    } // Create it


    fs.writeFileSync(filePath, JSON.stringify([]));
    const rawData = fs.readFileSync(filePath);
    return JSON.parse(rawData);
  } catch (err) {
    console.error(err);
  }
}

const fetch$1 = typeof window === 'undefined' ? require('node-fetch') : window.fetch;

function checkStatus(response) {
  if (response.ok) {
    return response;
  }

  return response.json().then(error => {
    error.response = response;
    throw error;
  });
}
/**
 * Makes a standardized HTTP Get request and returns response in JSON
 * @param {*} apiUrl Full API Url to request
 * @param {*} params Object of parameters
 * @param {*} accessToken JWT accessToken or authToken
 */


function makeHttpGetRequest(apiUrl, params, accessToken) {
  return fetch$1(apiUrl, params).then(checkStatus).then(response => {
    if (response.status === 204) {
      return null;
    }

    return response.json();
  });
}

function sanitizeValuesToFallback(data, input) {
  const paramKeys = Object.keys(input);
  return paramKeys.reduce((acc, paramName) => {
    const found = _$1.find(data, row => row.name === paramName || row.parameterName === paramName);

    if (found) {
      const {
        fallback,
        default: defaultValue
      } = found;

      if (!_$1.isNil(fallback) && fallback !== 'NULL' && _$1.isEqual(defaultValue, input[paramName])) {
        // Required parameters must have a value
        acc[paramName] = fallback;
        return acc;
      }
    }

    acc[paramName] = input[paramName];
    return acc;
  }, {});
}

function getByParameterType(paramName, parameters, type) {
  const found = _$1.find(parameters, row => row.in === type && (row.name === paramName || row.parameterName === paramName));

  return found;
}

function getParametersByType(data, input, type, withFallback = false) {
  const sanitizedInput = withFallback ? sanitizeValuesToFallback(data, input) : input;
  return _$1.pickBy(sanitizedInput, (paramValue, paramName) => getByParameterType(paramName, data, type));
}

/**
 * Compiles url from default data and form input parameters
 * @param {object} data Object that includes template string and parameters
 * @param {*} formParameters Updated form parameters from user input
 */

function compileUrl(data, formParameters) {
  const {
    template,
    parameters,
    alias
  } = data;
  const url = URI.parse(template);
  const {
    protocol,
    hostname,
    path
  } = url;

  try {
    const toPath = compile(path);
    const queryParameters = getParametersByType(parameters, formParameters, 'query');
    const query = URI.buildQuery(queryParameters);
    const parts = {
      protocol,
      hostname: alias || hostname,
      path: toPath(formParameters),
      query
    };
    return URI.build(parts);
  } catch (e) {
    return null;
  }
}

function handleResponse(response) {
  return response.json().then(json => {
    if (!response.ok) {
      const error = { ...json,
        status: response.status,
        statusText: response.statusText
      };
      return Promise.reject(error);
    }

    return json;
  });
}

function errorHandler$1(error) {
  console.log('Full error ===> ', error);
  const {
    status
  } = error;

  if (status === 404) {
    return Promise.reject({ ...error,
      statusText: 'Resource not found.'
    });
  }

  return Promise.reject({ ...error,
    statusText: 'We are having trouble with the request.'
  });
}

function sanitizeData(data) {
  const sanitizedData = _$1.omitBy(data, val => _$1.isNil(val) || val === '' || val === 0);

  return sanitizedData;
}

function fetchUrlAndSanitizeParams(url, data = {}) {
  // Turn url into URI object so we can build
  const authToken = localStorage.getItem('authToken');
  const csApiKey = localStorage.getItem('csApiKey');
  const fetchUrl = new URI(url); //   Omit null or undefined keys

  const queryKeys = sanitizeData(data);
  fetchUrl.query(URI.buildQuery(queryKeys));
  const builtUrl = fetchUrl.toString();
  return fetch(builtUrl, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'cs-api-key': csApiKey
    }
  }).then(handleResponse).catch(errorHandler$1);
}

function groupAndSanitizeParameters(data, input, withFallback = false) {
  const types = ['path', 'query', 'header', 'body'];
  return types.reduce((acc, type) => {
    const sanitizedParameterByType = getParametersByType(data, input, type, withFallback);
    acc[`${type}Parameters`] = sanitizedParameterByType;
    return acc;
  }, {});
}

function linkify(text) {
  const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
  return text.replace(urlRegex, function (url) {
    return `<a href="${url}">${url}</a>`;
  });
}

const protectedFunctions = ['OHLCV', 'OHLCVA'];
function multiIncludes(text, values) {
  const re = new RegExp(values.join('|'));
  return re.test(text);
}

/* eslint-disable no-shadow */
const functionName = 'AD';
const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName}(${parameters})`;
  }

  return `${namespace}${functionName}(${parameters}, ${global})`;
}

function buildString(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName}()`;
  }

  const {
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString,
    // R1C1: buildR1C1,
    A1: buildA1
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$1 = 'ADDRESS';

function buildA1$1(namespace, t, value) {
  const startRow = 3;
  const {
    address,
    name,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    address,
    name
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$1}(${parameters})`;
  }

  return `${namespace}${functionName$1}(${parameters}, ${global})`;
}

function buildString$1(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$1}()`;
  }

  const {
    address,
    name,
    ...rest
  } = value;
  let ohlcvParams = [address, name].map(param => {
    if (!_$1.isNil(param)) {
      return `"${param}"`;
    }

    return null;
  }).join(`${t}`);
  ohlcvParams = _$1.trimEnd(ohlcvParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$1}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$1}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$1({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$1,
    // R1C1: buildR1C1,
    A1: buildA1$1
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$2 = 'ADOSC';
const arrayTypes$1 = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$2(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$1.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$2}(${parameters})`;
  }

  return `${namespace}${functionName$2}(${parameters}, ${global})`;
}

function buildString$2(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$2}()`;
  }

  const {
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$1.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$2}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$2}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$2({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$2,
    // R1C1: buildR1C1,
    A1: buildA1$2
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$3 = 'ADX';
const arrayTypes$2 = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$3(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$2.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$3}(${parameters})`;
  }

  return `${namespace}${functionName$3}(${parameters}, ${global})`;
}

function buildString$3(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$3}()`;
  }

  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$2.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$3}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$3}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$3({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$3,
    // R1C1: buildR1C1,
    A1: buildA1$3
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$4 = 'APO';
const arrayTypes$3 = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$4(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    optInMAType,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    optInMAType,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$3.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$4}(${parameters})`;
  }

  return `${namespace}${functionName$4}(${parameters}, ${global})`;
}

function buildString$4(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$4}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    optInMAType,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    optInMAType,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$3.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$4}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$4}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$4({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$4,
    // R1C1: buildR1C1,
    A1: buildA1$4
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$5 = 'AROON';
const arrayTypes$4 = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$5(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$4.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$5}(${parameters})`;
  }

  return `${namespace}${functionName$5}(${parameters}, ${global})`;
}

function buildString$5(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$5}()`;
  }

  const {
    high,
    low,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$4.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$5}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$5}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$5({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$5,
    // R1C1: buildR1C1,
    A1: buildA1$5
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$6 = 'AROONOSC';
const arrayTypes$5 = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$6(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$5.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$6}(${parameters})`;
  }

  return `${namespace}${functionName$6}(${parameters}, ${global})`;
}

function buildString$6(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$6}()`;
  }

  const {
    high,
    low,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$5.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$6}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$6}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$6({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$6,
    // R1C1: buildR1C1,
    A1: buildA1$6
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$7 = 'ATH';

function buildA1$7(namespace, t, value) {
  const startRow = 3;
  const {
    base,
    quote,
    source,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    base,
    quote,
    source
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$7}(${parameters})`;
  }

  return `${namespace}${functionName$7}(${parameters}, ${global})`;
}

function buildString$7(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$7}()`;
  }

  const {
    base,
    quote,
    source,
    ...rest
  } = value;
  let ohlcvParams = [base, quote, source].map(param => {
    if (!_$1.isNil(param)) {
      return `"${param}"`;
    }

    return null;
  }).join(`${t}`);
  ohlcvParams = _$1.trimEnd(ohlcvParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$7}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$7}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$7({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$7,
    // R1C1: buildR1C1,
    A1: buildA1$7
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$8 = 'ATR';
const arrayTypes$6 = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$8(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$6.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$8}(${parameters})`;
  }

  return `${namespace}${functionName$8}(${parameters}, ${global})`;
}

function buildString$8(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$8}()`;
  }

  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$6.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$8}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$8}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$8({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$8,
    // R1C1: buildR1C1,
    A1: buildA1$8
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$9 = 'BBANDS';
const arrayTypes$7 = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$9(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInNbDevUp,
    optInNbDevDn,
    optInMAType,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInNbDevUp,
    optInNbDevDn,
    optInMAType,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$7.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$9}(${parameters})`;
  }

  return `${namespace}${functionName$9}(${parameters}, ${global})`;
}

function buildString$9(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$9}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInNbDevUp,
    optInNbDevDn,
    optInMAType,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInNbDevUp,
    optInNbDevDn,
    optInMAType,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$7.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$9}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$9}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$9({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$9,
    // R1C1: buildR1C1,
    A1: buildA1$9
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$a = 'BETA';
const arrayTypes$8 = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$a(namespace, t, value) {
  const startRow = 4;
  const {
    inReal0,
    inReal1,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal0,
    inReal1,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$8.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$a}(${parameters})`;
  }

  return `${namespace}${functionName$a}(${parameters}, ${global})`;
}

function buildString$a(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$a}()`;
  }

  const {
    inReal0,
    inReal1,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal0,
    inReal1,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$8.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$a}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$a}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$a({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$a,
    // R1C1: buildR1C1,
    A1: buildA1$a
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$b = 'CCI';
const arrayTypes$9 = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$b(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$9.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$b}(${parameters})`;
  }

  return `${namespace}${functionName$b}(${parameters}, ${global})`;
}

function buildString$b(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$b}()`;
  }

  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$9.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$b}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$b}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$b({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$b,
    // R1C1: buildR1C1,
    A1: buildA1$b
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$c = 'CDLINNECK';
const arrayTypes$a = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$c(namespace, t, value) {
  const startRow = 4;
  const {
    open,
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    open,
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$a.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$c}(${parameters})`;
  }

  return `${namespace}${functionName$c}(${parameters}, ${global})`;
}

function buildString$c(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$c}()`;
  }

  const {
    open,
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    open,
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$a.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$c}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$c}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$c({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$c,
    // R1C1: buildR1C1,
    A1: buildA1$c
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$d = 'CDLMARUBOZU';
const arrayTypes$b = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$d(namespace, t, value) {
  const startRow = 4;
  const {
    open,
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    open,
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$b.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$d}(${parameters})`;
  }

  return `${namespace}${functionName$d}(${parameters}, ${global})`;
}

function buildString$d(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$d}()`;
  }

  const {
    open,
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    open,
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$b.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$d}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$d}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$d({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$d,
    // R1C1: buildR1C1,
    A1: buildA1$d
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$e = 'CHAIN';

function buildA1$e(namespace, t, value) {
  const startRow = 3;
  const {
    symbol,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    symbol
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$e}(${parameters})`;
  }

  return `${namespace}${functionName$e}(${parameters}, ${global})`;
}

function buildString$e(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$e}()`;
  }

  const {
    symbol,
    ...rest
  } = value;
  let ohlcvParams = [symbol].map(param => {
    if (!_$1.isNil(param)) {
      return `"${param}"`;
    }

    return null;
  }).join(`${t}`);
  ohlcvParams = _$1.trimEnd(ohlcvParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$e}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$e}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$e({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$e,
    // R1C1: buildR1C1,
    A1: buildA1$e
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$f = 'CLUSTERS';

function buildA1$f(namespace, t, value) {
  const startRow = 3;
  const {
    clusterName,
    clusterType,
    clusterCategory,
    symbol,
    name,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    clusterName,
    clusterType,
    clusterCategory,
    symbol,
    name
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$f}(${parameters})`;
  }

  return `${namespace}${functionName$f}(${parameters}, ${global})`;
}

function buildString$f(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$f}()`;
  }

  const {
    clusterName,
    clusterType,
    clusterCategory,
    symbol,
    name,
    ...rest
  } = value;
  let ohlcvParams = [clusterName, clusterType, clusterCategory, symbol, name].map(param => {
    if (!_$1.isNil(param)) {
      return `"${param}"`;
    }

    return null;
  }).join(`${t}`);
  ohlcvParams = _$1.trimEnd(ohlcvParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$f}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$f}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$f({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$f,
    // R1C1: buildR1C1,
    A1: buildA1$f
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$g = 'CORREL';
const arrayTypes$c = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$g(namespace, t, value) {
  const startRow = 4;
  const {
    inReal0,
    inReal1,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal0,
    inReal1,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$c.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$g}(${parameters})`;
  }

  return `${namespace}${functionName$g}(${parameters}, ${global})`;
}

function buildString$g(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$g}()`;
  }

  const {
    inReal0,
    inReal1,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal0,
    inReal1,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$c.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$g}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$g}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$g({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$g,
    // R1C1: buildR1C1,
    A1: buildA1$g
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$h = 'DEMA';
const arrayTypes$d = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$h(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$d.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$h}(${parameters})`;
  }

  return `${namespace}${functionName$h}(${parameters}, ${global})`;
}

function buildString$h(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$h}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$d.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$h}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$h}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$h({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$h,
    // R1C1: buildR1C1,
    A1: buildA1$h
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$i = 'DX';
const arrayTypes$e = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$i(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$e.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$i}(${parameters})`;
  }

  return `${namespace}${functionName$i}(${parameters}, ${global})`;
}

function buildString$i(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$i}()`;
  }

  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$e.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$i}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$i}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$i({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$i,
    // R1C1: buildR1C1,
    A1: buildA1$i
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$j = 'EMA';
const arrayTypes$f = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$j(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$f.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$j}(${parameters})`;
  }

  return `${namespace}${functionName$j}(${parameters}, ${global})`;
}

function buildString$j(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$j}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$f.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$j}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$j}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$j({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$j,
    // R1C1: buildR1C1,
    A1: buildA1$j
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$k = 'ENDPOINTS';

function buildA1$k(namespace, t, value) {
  const startRow = 3;
  const {
    providerName,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    providerName
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$k}(${parameters})`;
  }

  return `${namespace}${functionName$k}(${parameters}, ${global})`;
}

function buildString$k(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$k}()`;
  }

  const {
    providerName,
    ...rest
  } = value;
  const params = [providerName].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$k}(${params})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$k}(${params}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$k({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$k,
    // R1C1: buildR1C1,
    A1: buildA1$k
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$l = 'EXCHANGES';

function buildA1$l(namespace, t, value) {
  const startRow = 3;
  const {
    name,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    name
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$l}(${parameters})`;
  }

  return `${namespace}${functionName$l}(${parameters}, ${global})`;
}

function buildString$l(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$l}()`;
  }

  const {
    name,
    ...rest
  } = value;
  const ohlcvParams = [name].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$l}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$l}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$l({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$l,
    // R1C1: buildR1C1,
    A1: buildA1$l
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$m = 'EXP';
const arrayTypes$g = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$m(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$g.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$m}(${parameters})`;
  }

  return `${namespace}${functionName$m}(${parameters}, ${global})`;
}

function buildString$m(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$m}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$g.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$m}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$m}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$m({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$m,
    // R1C1: buildR1C1,
    A1: buildA1$m
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$n = 'EXRATE';

function buildA1$n(namespace, t, value, firstColumn) {
  const {
    base = '',
    quote = '',
    refresh = ''
  } = value;

  if (_$1.isNil(refresh) || _$1.isEmpty(refresh)) {
    return `${namespace}${functionName$n}(B3,B4)`;
  }

  return `${namespace}${functionName$n}(B3,B4,B5)`;
}

function buildString$n(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$n}()`;
  }

  const {
    base,
    quote,
    refresh,
    ...rest
  } = value;
  const ohlcvParams = [base, quote, refresh].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$n}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$n}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$n({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$n,
    // R1C1: buildR1C1,
    A1: buildA1$n
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$o = 'FIELDS';

function buildA1$o(namespace, t, value, firstColumn) {
  const startRow = 3;

  const parameters = _$1.reduce(Object.keys(value), function (result, value, index) {
    // Argument
    result.push(`A${index + startRow}`); // Value

    result.push(`B${index + startRow}`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$o}()`;
  }

  return `${namespace}${functionName$o}(${parameters})`;
}

function buildString$o(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$o}()`;
  }

  const parameters = _$1.reduce(value, function (result, val, key) {
    result.push(`"${key}"`);
    result.push(`"${val}"`);
    return result;
  }, []).join(`${t}`);

  return `${namespace}${functionName$o}(${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$o({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$o,
    // R1C1: buildR1C1,
    A1: buildA1$o
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$p = 'FLOOR';
const arrayTypes$h = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$p(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$h.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$p}(${parameters})`;
  }

  return `${namespace}${functionName$p}(${parameters}, ${global})`;
}

function buildString$p(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$p}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$h.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$p}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$p}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$p({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$p,
    // R1C1: buildR1C1,
    A1: buildA1$p
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$q = 'IDEAS';

function buildA1$q(namespace, t, value) {
  const startRow = 3;
  const {
    keywords,
    dataType,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    keywords,
    dataType
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$q}(${parameters})`;
  }

  return `${namespace}${functionName$q}(${parameters}, ${global})`;
}

function buildString$q(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$q}()`;
  }

  const {
    keywords,
    dataType,
    provider,
    endpoint,
    ...rest
  } = value;
  const ohlcvParams = [keywords, dataType].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$q}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$q}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$q({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$q,
    // R1C1: buildR1C1,
    A1: buildA1$q
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$r = 'LINEARREG';
const arrayTypes$i = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$r(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$i.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$r}(${parameters})`;
  }

  return `${namespace}${functionName$r}(${parameters}, ${global})`;
}

function buildString$r(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$r}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$i.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$r}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$r}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$r({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$r,
    // R1C1: buildR1C1,
    A1: buildA1$r
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$s = 'LINEARREG_ANGLE';
const arrayTypes$j = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$s(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$j.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$s}(${parameters})`;
  }

  return `${namespace}${functionName$s}(${parameters}, ${global})`;
}

function buildString$s(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$s}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$j.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$s}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$s}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$s({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$s,
    // R1C1: buildR1C1,
    A1: buildA1$s
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$t = 'LINEARREG_INTERCEPT';
const arrayTypes$k = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$t(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$k.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$t}(${parameters})`;
  }

  return `${namespace}${functionName$t}(${parameters}, ${global})`;
}

function buildString$t(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$t}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$k.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$t}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$t}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$t({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$t,
    // R1C1: buildR1C1,
    A1: buildA1$t
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$u = 'LINEARREG_SLOPE';
const arrayTypes$l = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$u(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$l.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$u}(${parameters})`;
  }

  return `${namespace}${functionName$u}(${parameters}, ${global})`;
}

function buildString$u(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$u}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$l.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$u}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$u}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$u({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$u,
    // R1C1: buildR1C1,
    A1: buildA1$u
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$v = 'LN';
const arrayTypes$m = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$v(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$m.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$v}(${parameters})`;
  }

  return `${namespace}${functionName$v}(${parameters}, ${global})`;
}

function buildString$v(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$v}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$m.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$v}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$v}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$v({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$v,
    // R1C1: buildR1C1,
    A1: buildA1$v
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$w = 'LOGIN';

function buildA1$w(namespace, t, value) {
  const startRow = 3;
  const {
    email,
    password,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    email,
    password
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$w}(${parameters})`;
  }

  return `${namespace}${functionName$w}(${parameters}, ${global})`;
}

function buildString$w(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$w}()`;
  }

  const {
    email,
    password,
    ...rest
  } = value;
  const ohlcvParams = [email, password].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$w}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$w}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$w({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$w,
    // R1C1: buildR1C1,
    A1: buildA1$w
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$x = 'MACD';
const arrayTypes$n = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$x(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    optInSignalPeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    optInSignalPeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$n.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$x}(${parameters})`;
  }

  return `${namespace}${functionName$x}(${parameters}, ${global})`;
}

function buildString$x(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$x}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    optInSignalPeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    optInSignalPeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$n.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$x}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$x}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$x({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$x,
    // R1C1: buildR1C1,
    A1: buildA1$x
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$y = 'MACDEXT';
const arrayTypes$o = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$y(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInFastMAType,
    optInSlowPeriod,
    optInSlowMAType,
    optInSignalPeriod,
    optInSignalMAType,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInFastMAType,
    optInSlowPeriod,
    optInSlowMAType,
    optInSignalPeriod,
    optInSignalMAType,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$o.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$y}(${parameters})`;
  }

  return `${namespace}${functionName$y}(${parameters}, ${global})`;
}

function buildString$y(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$y}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInFastMAType,
    optInSlowPeriod,
    optInSlowMAType,
    optInSignalPeriod,
    optInSignalMAType,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInFastMAType,
    optInSlowPeriod,
    optInSlowMAType,
    optInSignalPeriod,
    optInSignalMAType,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$o.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$y}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$y}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$y({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$y,
    // R1C1: buildR1C1,
    A1: buildA1$y
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$z = 'MACDFIX';
const arrayTypes$p = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$z(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInSignalPeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInSignalPeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$p.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$z}(${parameters})`;
  }

  return `${namespace}${functionName$z}(${parameters}, ${global})`;
}

function buildString$z(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$z}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInSignalPeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInSignalPeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$p.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$z}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$z}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$z({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$z,
    // R1C1: buildR1C1,
    A1: buildA1$z
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$A = 'METRICS';

function buildA1$A(namespace, t, value) {
  const startRow = 3;
  const {
    symbol,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    symbol
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$A}(${parameters})`;
  }

  return `${namespace}${functionName$A}(${parameters}, ${global})`;
}

function buildString$A(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$A}()`;
  }

  const {
    symbol,
    ...rest
  } = value;
  const ohlcvParams = [symbol].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$A}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$A}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$A({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$A,
    // R1C1: buildR1C1,
    A1: buildA1$A
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$B = 'METRICSA';

function buildA1$B(namespace, t, value, firstColumn) {
  const startRow = 3;

  const parameters = _$1.reduce(Object.keys(value), function (result, value, index) {
    // Argument
    result.push(`A${index + startRow}`); // Value

    result.push(`B${index + startRow}`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$B}()`;
  }

  return `${namespace}${functionName$B}(${parameters})`;
}

function buildR1C1(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  const parameters = _$1.reduce(Object.keys(rest), function (result, value, index) {
    // Argument
    result.push(`R[${index + 1}]C[-2]`); // Value

    result.push(`R[${index + 1}]C[-1]`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$B}(R[-1]C[-1],R[0]C[-1]`;
  }

  return `${namespace}${functionName$B}(R[-1]C[-1],R[0]C[-1],${parameters}`;
}

function buildString$B(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$B}()`;
  }

  const parameters = _$1.reduce(value, function (result, val, key) {
    result.push(`"${key}"`);
    result.push(`"${val}"`);
    return result;
  }, []).join(`${t}`);

  return `${namespace}${functionName$B}(${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$B({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$B,
    R1C1: buildR1C1,
    A1: buildA1$B
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$C = 'MFI';
const arrayTypes$q = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$C(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$q.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$C}(${parameters})`;
  }

  return `${namespace}${functionName$C}(${parameters}, ${global})`;
}

function buildString$C(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$C}()`;
  }

  const {
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$q.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$C}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$C}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$C({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$C,
    // R1C1: buildR1C1,
    A1: buildA1$C
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$D = 'MOM';
const arrayTypes$r = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$D(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$r.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$D}(${parameters})`;
  }

  return `${namespace}${functionName$D}(${parameters}, ${global})`;
}

function buildString$D(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$D}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$r.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$D}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$D}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$D({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$D,
    // R1C1: buildR1C1,
    A1: buildA1$D
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$E = 'NATR';
const arrayTypes$s = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$E(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$s.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$E}(${parameters})`;
  }

  return `${namespace}${functionName$E}(${parameters}, ${global})`;
}

function buildString$E(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$E}()`;
  }

  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$s.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$E}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$E}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$E({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$E,
    // R1C1: buildR1C1,
    A1: buildA1$E
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$F = 'OBV';
const arrayTypes$t = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$F(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    volume,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    volume,
    startIdx,
    endIdx,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$t.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$F}(${parameters})`;
  }

  return `${namespace}${functionName$F}(${parameters}, ${global})`;
}

function buildString$F(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$F}()`;
  }

  const {
    inReal,
    volume,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    volume,
    startIdx,
    endIdx,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$t.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$F}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$F}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$F({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$F,
    // R1C1: buildR1C1,
    A1: buildA1$F
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$G = 'OHLCV';

function buildA1$G(namespace, t, value) {
  const startRow = 3;
  const {
    base,
    quote,
    exchange,
    type,
    period,
    timeStart,
    timeEnd,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    base,
    quote,
    exchange,
    type,
    period,
    timeStart,
    timeEnd
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$G}(${parameters})`;
  }

  return `${namespace}${functionName$G}(${parameters}, ${global})`;
}

function buildString$G(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$G}()`;
  }

  const {
    base,
    quote,
    exchange,
    type,
    period,
    timeStart,
    timeEnd,
    ...rest
  } = value;
  let ohlcvParams = [base, quote, exchange, type, period, timeStart, timeEnd].map(param => {
    if (!_$1.isNil(param)) {
      return `"${param}"`;
    }

    return null;
  }).join(`${t}`);
  ohlcvParams = _$1.trimEnd(ohlcvParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$G}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$G}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$G({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$G,
    // R1C1: buildR1C1,
    A1: buildA1$G
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$H = 'OHLCVA';

function buildA1$H(namespace, t, value, firstColumn) {
  const startRow = 3;

  const parameters = _$1.reduce(Object.keys(value), function (result, value, index) {
    // Argument
    result.push(`A${index + startRow}`); // Value

    result.push(`B${index + startRow}`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$H}()`;
  }

  return `${namespace}${functionName$H}(${parameters})`;
}

function buildR1C1$1(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  const parameters = _$1.reduce(Object.keys(rest), function (result, value, index) {
    // Argument
    result.push(`R[${index + 1}]C[-2]`); // Value

    result.push(`R[${index + 1}]C[-1]`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$H}(R[-1]C[-1],R[0]C[-1]`;
  }

  return `${namespace}${functionName$H}(R[-1]C[-1],R[0]C[-1],${parameters}`;
}

function buildString$H(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$H}()`;
  }

  const parameters = _$1.reduce(value, function (result, val, key) {
    result.push(`"${key}"`);
    result.push(`"${val}"`);
    return result;
  }, []).join(`${t}`);

  return `${namespace}${functionName$H}(${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$H({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$H,
    R1C1: buildR1C1$1,
    A1: buildA1$H
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$I = 'ORDERBOOKS';

function buildA1$I(namespace, t, value) {
  const startRow = 3;
  const {
    base,
    quote,
    exchange,
    type,
    timeStart,
    timeEnd,
    limitLevels,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    base,
    quote,
    exchange,
    type,
    timeStart,
    timeEnd,
    limitLevels
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$I}(${parameters})`;
  }

  return `${namespace}${functionName$I}(${parameters}, ${global})`;
}

function buildString$I(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$I}()`;
  }

  const {
    base,
    quote,
    exchange,
    type,
    timeStart,
    timeEnd,
    limitLevels,
    ...rest
  } = value;
  const ohlcvParams = [base, quote, exchange, type, timeStart, timeEnd, limitLevels].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$I}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$I}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$I({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$I,
    // R1C1: buildR1C1,
    A1: buildA1$I
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$J = 'ORDERBOOKSA';

function buildA1$J(namespace, t, value, firstColumn) {
  const startRow = 3;

  const parameters = _$1.reduce(Object.keys(value), function (result, value, index) {
    // Argument
    result.push(`A${index + startRow}`); // Value

    result.push(`B${index + startRow}`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$J}()`;
  }

  return `${namespace}${functionName$J}(${parameters})`;
}

function buildR1C1$2(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  const parameters = _$1.reduce(Object.keys(rest), function (result, value, index) {
    // Argument
    result.push(`R[${index + 1}]C[-2]`); // Value

    result.push(`R[${index + 1}]C[-1]`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$J}(R[-1]C[-1],R[0]C[-1]`;
  }

  return `${namespace}${functionName$J}(R[-1]C[-1],R[0]C[-1],${parameters}`;
}

function buildString$J(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$J}()`;
  }

  const parameters = _$1.reduce(value, function (result, val, key) {
    result.push(`"${key}"`);
    result.push(`"${val}"`);
    return result;
  }, []).join(`${t}`);

  return `${namespace}${functionName$J}(${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$J({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$J,
    R1C1: buildR1C1$2,
    A1: buildA1$J
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$K = 'ORDERBOOKSL3A';

function buildA1$K(namespace, t, value, firstColumn) {
  const startRow = 3;

  const parameters = _$1.reduce(Object.keys(value), function (result, value, index) {
    // Argument
    result.push(`A${index + startRow}`); // Value

    result.push(`B${index + startRow}`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$K}()`;
  }

  return `${namespace}${functionName$K}(${parameters})`;
}

function buildR1C1$3(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  const parameters = _$1.reduce(Object.keys(rest), function (result, value, index) {
    // Argument
    result.push(`R[${index + 1}]C[-2]`); // Value

    result.push(`R[${index + 1}]C[-1]`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$K}(R[-1]C[-1],R[0]C[-1]`;
  }

  return `${namespace}${functionName$K}(R[-1]C[-1],R[0]C[-1],${parameters}`;
}

function buildString$K(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$K}()`;
  }

  const parameters = _$1.reduce(value, function (result, val, key) {
    result.push(`"${key}"`);
    result.push(`"${val}"`);
    return result;
  }, []).join(`${t}`);

  return `${namespace}${functionName$K}(${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$K({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$K,
    R1C1: buildR1C1$3,
    A1: buildA1$K
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$L = 'PARAMETERS';

function buildA1$L(namespace, t, value) {
  const startRow = 3;
  const {
    providerName,
    endpointName,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    providerName,
    endpointName
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$L}(${parameters})`;
  }

  return `${namespace}${functionName$L}(${parameters}, ${global})`;
}

function buildString$L(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$L}()`;
  }

  const {
    providerName,
    endpointName,
    ...rest
  } = value;
  const ohlcvParams = [providerName, endpointName].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$L}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$L}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$L({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$L,
    // R1C1: buildR1C1,
    A1: buildA1$L
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$M = 'PRICE';

function buildA1$M(namespace, t, value) {
  const startRow = 3;
  const {
    base,
    quote,
    time,
    exchange,
    returnValue,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    base,
    quote,
    time,
    exchange,
    returnValue
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$M}(${parameters})`;
  }

  return `${namespace}${functionName$M}(${parameters}, ${global})`;
}

function buildString$M(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$M}()`;
  }

  const {
    base,
    quote,
    time,
    exchange,
    returnValue,
    ...rest
  } = value;
  const ohlcvParams = [base, quote, time, exchange, returnValue].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$M}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$M}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$M({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$M,
    // R1C1: buildR1C1,
    A1: buildA1$M
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$N = 'PRICEA';

function buildA1$N(namespace, t, value, firstColumn) {
  const startRow = 3;

  const parameters = _$1.reduce(Object.keys(value), function (result, value, index) {
    // Argument
    result.push(`A${index + startRow}`); // Value

    result.push(`B${index + startRow}`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$N}()`;
  }

  return `${namespace}${functionName$N}(${parameters})`;
}

function buildR1C1$4(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  const parameters = _$1.reduce(Object.keys(rest), function (result, value, index) {
    // Argument
    result.push(`R[${index + 1}]C[-2]`); // Value

    result.push(`R[${index + 1}]C[-1]`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$N}(R[-1]C[-1],R[0]C[-1]`;
  }

  return `${namespace}${functionName$N}(R[-1]C[-1],R[0]C[-1],${parameters}`;
}

function buildString$N(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$N}()`;
  }

  const parameters = _$1.reduce(value, function (result, val, key) {
    result.push(`"${key}"`);
    result.push(`"${val}"`);
    return result;
  }, []).join(`${t}`);

  return `${namespace}${functionName$N}(${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$N({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$N,
    R1C1: buildR1C1$4,
    A1: buildA1$N
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$O = 'PROVIDERS';

function buildA1$O(namespace, t, value) {
  const startRow = 3;
  const {
    providerName,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    providerName
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$O}(${parameters})`;
  }

  return `${namespace}${functionName$O}(${parameters}, ${global})`;
}

function buildString$O(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$O}()`;
  }

  const {
    providerName,
    ...rest
  } = value;
  const ohlcvParams = [providerName].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$O}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$O}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$O({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$O,
    // R1C1: buildR1C1,
    A1: buildA1$O
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$P = 'QUERY';

function buildA1$P(namespace, t, value, firstColumn) {
  const startRow = 3;
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$P}(B3,B4)`;
  }

  const parameterStart = startRow + 2;
  const parameters = `A${parameterStart}:B${_$1.size(rest) + parameterStart - 1}`;
  return `${namespace}${functionName$P}(B3,B4, ${parameters})`;
}

function buildR1C1$5(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$P}(R[-1]C[-1],R[0]C[-1]`;
  }

  const parameters = `R[1]C[-2]:R[${_$1.size(rest) + 2}]C[-1]]`;
  return `${namespace}${functionName$P}(R[-1]C[-1],R[0]C[-1],${parameters}`;
}

function buildString$P(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$P}("${provider}"${t}"${endpoint}")`;
  }

  const parameters = _$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`);

  return `${namespace}${functionName$P}("${provider}"${t}"${endpoint}"${t}{${parameters}})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$P({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$P,
    R1C1: buildR1C1$5,
    A1: buildA1$P
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$Q = 'QUERYA';

function buildA1$Q(namespace, t, value) {
  const startRow = 3;
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  const parameters = _$1.reduce(Object.keys(rest), function (result, value, index) {
    // Argument
    result.push(`A${index + startRow + 2}`); // Value

    result.push(`B${index + startRow + 2}`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$Q}(B3,B4)`;
  }

  return `${namespace}${functionName$Q}(B3,B4, ${parameters})`;
}

function buildR1C1$6(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  const parameters = _$1.reduce(Object.keys(rest), function (result, value, index) {
    // Argument
    result.push(`R[${index + 1}]C[-2]`); // Value

    result.push(`R[${index + 1}]C[-1]`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$Q}(R[-1]C[-1],R[0]C[-1]`;
  }

  return `${namespace}${functionName$Q}(R[-1]C[-1],R[0]C[-1],${parameters}`;
}

function buildString$Q(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$Q}("${provider}"${t}"${endpoint}")`;
  }

  const parameters = _$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"`);
    result.push(`"${val}"`);
    return result;
  }, []).join(`${t}`);

  return `${namespace}${functionName$Q}("${provider}"${t}"${endpoint}"${t}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$Q({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$Q,
    R1C1: buildR1C1$6,
    A1: buildA1$Q
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$R = 'ROC';
const arrayTypes$u = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$R(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$u.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$R}(${parameters})`;
  }

  return `${namespace}${functionName$R}(${parameters}, ${global})`;
}

function buildString$R(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$R}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$u.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$R}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$R}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$R({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$R,
    // R1C1: buildR1C1,
    A1: buildA1$R
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$S = 'ROCP';
const arrayTypes$v = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$S(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$v.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$S}(${parameters})`;
  }

  return `${namespace}${functionName$S}(${parameters}, ${global})`;
}

function buildString$S(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$S}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$v.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$S}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$S}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$S({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$S,
    // R1C1: buildR1C1,
    A1: buildA1$S
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$T = 'ROCR';
const arrayTypes$w = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$T(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$w.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$T}(${parameters})`;
  }

  return `${namespace}${functionName$T}(${parameters}, ${global})`;
}

function buildString$T(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$T}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$w.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$T}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$T}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$T({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$T,
    // R1C1: buildR1C1,
    A1: buildA1$T
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$U = 'RSI';
const arrayTypes$x = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$U(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$x.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$U}(${parameters})`;
  }

  return `${namespace}${functionName$U}(${parameters}, ${global})`;
}

function buildString$U(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$U}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$x.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$U}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$U}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$U({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$U,
    // R1C1: buildR1C1,
    A1: buildA1$U
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$V = 'SAREXT';
const arrayTypes$y = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$V(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    startIdx,
    endIdx,
    optInStartValue,
    optInOffsetOnReverse,
    optInAccelerationInitLong,
    optInAccelerationLong,
    optInAccelerationMaxLong,
    optInAccelerationInitShort,
    optInAccelerationShort,
    optInAccelerationMaxShort,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    startIdx,
    endIdx,
    optInStartValue,
    optInOffsetOnReverse,
    optInAccelerationInitLong,
    optInAccelerationLong,
    optInAccelerationMaxLong,
    optInAccelerationInitShort,
    optInAccelerationShort,
    optInAccelerationMaxShort,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$y.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$V}(${parameters})`;
  }

  return `${namespace}${functionName$V}(${parameters}, ${global})`;
}

function buildString$V(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$V}()`;
  }

  const {
    high,
    low,
    startIdx,
    endIdx,
    optInStartValue,
    optInOffsetOnReverse,
    optInAccelerationInitLong,
    optInAccelerationLong,
    optInAccelerationMaxLong,
    optInAccelerationInitShort,
    optInAccelerationShort,
    optInAccelerationMaxShort,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    startIdx,
    endIdx,
    optInStartValue,
    optInOffsetOnReverse,
    optInAccelerationInitLong,
    optInAccelerationLong,
    optInAccelerationMaxLong,
    optInAccelerationInitShort,
    optInAccelerationShort,
    optInAccelerationMaxShort,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$y.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$V}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$V}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$V({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$V,
    // R1C1: buildR1C1,
    A1: buildA1$V
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$W = 'SMA';
const arrayTypes$z = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$W(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$z.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$W}(${parameters})`;
  }

  return `${namespace}${functionName$W}(${parameters}, ${global})`;
}

function buildString$W(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$W}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$z.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$W}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$W}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$W({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$W,
    // R1C1: buildR1C1,
    A1: buildA1$W
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$X = 'STATUS';

function buildA1$X(namespace, t, value) {
  return `${namespace}${functionName$X}()`;
}

function buildString$X(namespace, t, value) {
  return `${namespace}${functionName$X}()`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$X({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$X,
    // R1C1: buildR1C1,
    A1: buildA1$X
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$Y = 'STOCH';
const arrayTypes$A = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$Y(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInFastK_Period,
    optInSlowK_Period,
    optInSlowK_MAType,
    optInSlowD_Period,
    optInSlowD_MAType,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInFastK_Period,
    optInSlowK_Period,
    optInSlowK_MAType,
    optInSlowD_Period,
    optInSlowD_MAType,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$A.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$Y}(${parameters})`;
  }

  return `${namespace}${functionName$Y}(${parameters}, ${global})`;
}

function buildString$Y(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$Y}()`;
  }

  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInFastK_Period,
    optInSlowK_Period,
    optInSlowK_MAType,
    optInSlowD_Period,
    optInSlowD_MAType,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInFastK_Period,
    optInSlowK_Period,
    optInSlowK_MAType,
    optInSlowD_Period,
    optInSlowD_MAType,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$A.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$Y}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$Y}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$Y({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$Y,
    // R1C1: buildR1C1,
    A1: buildA1$Y
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$Z = 'SYMBOLS';

function buildA1$Z(namespace, t, value, firstColumn) {
  const startRow = 3;

  const parameters = _$1.reduce(Object.keys(value), function (result, value, index) {
    // Argument
    result.push(`A${index + startRow}`); // Value

    result.push(`B${index + startRow}`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$Z}()`;
  }

  return `${namespace}${functionName$Z}(${parameters})`;
}

function buildString$Z(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$Z}()`;
  }

  const parameters = _$1.reduce(value, function (result, val, key) {
    result.push(`"${key}"`);
    result.push(`"${val}"`);
    return result;
  }, []).join(`${t}`);

  return `${namespace}${functionName$Z}(${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$Z({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$Z,
    // R1C1: buildR1C1,
    A1: buildA1$Z
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$_ = 'T3';
const arrayTypes$B = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$_(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInVFactor,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInVFactor,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$B.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$_}(${parameters})`;
  }

  return `${namespace}${functionName$_}(${parameters}, ${global})`;
}

function buildString$_(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$_}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInVFactor,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInVFactor,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$B.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$_}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$_}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$_({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$_,
    // R1C1: buildR1C1,
    A1: buildA1$_
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$$ = 'TA';

function buildA1$$(namespace, t, value) {
  const startRow = 3;
  const {
    base,
    quote,
    exchange,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    base,
    quote,
    exchange
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$$}(${parameters})`;
  }

  return `${namespace}${functionName$$}(${parameters}, ${global})`;
}

function buildString$$(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$$}()`;
  }

  const {
    base,
    quote,
    exchange,
    ...rest
  } = value;
  let ohlcvParams = [base, quote, exchange].map(param => {
    if (!_$1.isNil(param)) {
      return `"${param}"`;
    }

    return null;
  }).join(`${t}`);
  ohlcvParams = _$1.trimEnd(ohlcvParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$$}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$$}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$$({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$$,
    // R1C1: buildR1C1,
    A1: buildA1$$
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$10 = 'TAHIS';

function buildA1$10(namespace, t, value) {
  const startRow = 3;
  const {
    base,
    quote,
    exchange,
    datetimeUTC,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    base,
    quote,
    exchange,
    datetimeUTC
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$10}(${parameters})`;
  }

  return `${namespace}${functionName$10}(${parameters}, ${global})`;
}

function buildString$10(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$10}()`;
  }

  const {
    base,
    quote,
    exchange,
    datetimeUTC,
    ...rest
  } = value;
  let ohlcvParams = [base, quote, exchange, datetimeUTC].map(param => {
    if (!_$1.isNil(param)) {
      return `"${param}"`;
    }

    return null;
  }).join(`${t}`);
  ohlcvParams = _$1.trimEnd(ohlcvParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$10}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$10}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$10({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$10,
    // R1C1: buildR1C1,
    A1: buildA1$10
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$11 = 'TAMETADATA';

function buildA1$11(namespace, t, value) {
  const startRow = 3;
  const {
    indicator,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    indicator
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$11}(${parameters})`;
  }

  return `${namespace}${functionName$11}(${parameters}, ${global})`;
}

function buildString$11(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$11}()`;
  }

  const {
    indicator,
    ...rest
  } = value;
  const ohlcvParams = [indicator].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$11}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$11}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$11({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$11,
    // R1C1: buildR1C1,
    A1: buildA1$11
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$12 = 'TEMA';
const arrayTypes$C = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$12(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$C.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$12}(${parameters})`;
  }

  return `${namespace}${functionName$12}(${parameters}, ${global})`;
}

function buildString$12(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$12}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$C.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$12}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$12}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$12({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$12,
    // R1C1: buildR1C1,
    A1: buildA1$12
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$13 = 'TIME';

function buildA1$13(namespace, t, value) {
  const startRow = 3;
  const {
    refresh,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    refresh
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$13}(${parameters})`;
  }

  return `${namespace}${functionName$13}(${parameters}, ${global})`;
}

function buildString$13(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$13}()`;
  }

  const {
    refresh,
    ...rest
  } = value;
  const ohlcvParams = [refresh].map(param => {
    if (!_$1.isNil(param) || param === '') {
      return `"${param}"`;
    }

    return '';
  }).filter(Boolean).join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$13}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$13}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$13({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$13,
    // R1C1: buildR1C1,
    A1: buildA1$13
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$14 = 'TRADES';

function buildA1$14(namespace, t, value) {
  const startRow = 3;
  const {
    base,
    quote,
    exchange,
    type,
    timeStart,
    timeEnd,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    base,
    quote,
    exchange,
    type,
    timeStart,
    timeEnd
  }, (result, value, key) => {
    if (_$1.isNil(value) || value === '') {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$14}(${parameters})`;
  }

  return `${namespace}${functionName$14}(${parameters}, ${global})`;
}

function buildString$14(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$14}()`;
  }

  const {
    base,
    quote,
    exchange,
    type,
    timeStart,
    timeEnd,
    ...rest
  } = value;
  const ohlcvParams = [base, quote, exchange, type, timeStart, timeEnd].map(param => {
    if (!_$1.isNil(param)) {
      return `"${param}"`;
    }

    return null;
  }) // .filter(Boolean)
  .join(`${t}`);

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$14}(${ohlcvParams})`;
  }

  const parameters = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$14}(${ohlcvParams}${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$14({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$14,
    // R1C1: buildR1C1,
    A1: buildA1$14
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

const functionName$15 = 'TRADESA';

function buildA1$15(namespace, t, value, firstColumn) {
  const startRow = 3;

  const parameters = _$1.reduce(Object.keys(value), function (result, value, index) {
    // Argument
    result.push(`A${index + startRow}`); // Value

    result.push(`B${index + startRow}`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$15}()`;
  }

  return `${namespace}${functionName$15}(${parameters})`;
}

function buildR1C1$7(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  const parameters = _$1.reduce(Object.keys(rest), function (result, value, index) {
    // Argument
    result.push(`R[${index + 1}]C[-2]`); // Value

    result.push(`R[${index + 1}]C[-1]`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$15}(R[-1]C[-1],R[0]C[-1]`;
  }

  return `${namespace}${functionName$15}(R[-1]C[-1],R[0]C[-1],${parameters}`;
}

function buildString$15(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$15}()`;
  }

  const parameters = _$1.reduce(value, function (result, val, key) {
    result.push(`"${key}"`);
    result.push(`"${val}"`);
    return result;
  }, []).join(`${t}`);

  return `${namespace}${functionName$15}(${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$15({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$15,
    R1C1: buildR1C1$7,
    A1: buildA1$15
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$16 = 'TRANGE';
const arrayTypes$D = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$16(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$D.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$16}(${parameters})`;
  }

  return `${namespace}${functionName$16}(${parameters}, ${global})`;
}

function buildString$16(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$16}()`;
  }

  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$D.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$16}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$16}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$16({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$16,
    // R1C1: buildR1C1,
    A1: buildA1$16
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$17 = 'TRIX';
const arrayTypes$E = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$17(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$E.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$17}(${parameters})`;
  }

  return `${namespace}${functionName$17}(${parameters}, ${global})`;
}

function buildString$17(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$17}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$E.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$17}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$17}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$17({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$17,
    // R1C1: buildR1C1,
    A1: buildA1$17
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$18 = 'TSF';
const arrayTypes$F = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$18(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$F.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$18}(${parameters})`;
  }

  return `${namespace}${functionName$18}(${parameters}, ${global})`;
}

function buildString$18(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$18}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$F.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$18}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$18}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$18({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$18,
    // R1C1: buildR1C1,
    A1: buildA1$18
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$19 = 'ULTOSC';
const arrayTypes$G = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$19(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod1,
    optInTimePeriod2,
    optInTimePeriod3,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod1,
    optInTimePeriod2,
    optInTimePeriod3,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$G.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$19}(${parameters})`;
  }

  return `${namespace}${functionName$19}(${parameters}, ${global})`;
}

function buildString$19(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$19}()`;
  }

  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod1,
    optInTimePeriod2,
    optInTimePeriod3,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod1,
    optInTimePeriod2,
    optInTimePeriod3,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$G.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$19}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$19}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$19({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$19,
    // R1C1: buildR1C1,
    A1: buildA1$19
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$1a = 'VAR';
const arrayTypes$H = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$1a(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInNbDev,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInNbDev,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$H.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$1a}(${parameters})`;
  }

  return `${namespace}${functionName$1a}(${parameters}, ${global})`;
}

function buildString$1a(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$1a}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInNbDev,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInNbDev,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$H.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$1a}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$1a}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$1a({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$1a,
    // R1C1: buildR1C1,
    A1: buildA1$1a
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$1b = 'WCLPRICE';
const arrayTypes$I = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$1b(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$I.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$1b}(${parameters})`;
  }

  return `${namespace}${functionName$1b}(${parameters}, ${global})`;
}

function buildString$1b(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$1b}()`;
  }

  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$I.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$1b}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$1b}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$1b({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$1b,
    // R1C1: buildR1C1,
    A1: buildA1$1b
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$1c = 'WILLR';
const arrayTypes$J = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$1c(namespace, t, value) {
  const startRow = 4;
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$J.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$1c}(${parameters})`;
  }

  return `${namespace}${functionName$1c}(${parameters}, ${global})`;
}

function buildString$1c(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$1c}()`;
  }

  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$J.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$1c}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$1c}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$1c({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$1c,
    // R1C1: buildR1C1,
    A1: buildA1$1c
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$1d = 'WMA';
const arrayTypes$K = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];

function buildA1$1d(namespace, t, value) {
  const startRow = 4;
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  let currentRow = startRow;

  const parameters = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, function (result, value, key) {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      currentRow += 1;
      return result;
    }

    if (arrayTypes$K.includes(key)) {
      const newValue = value.split(',');
      result.push(`B${currentRow}:B${currentRow + newValue.length - 1}`);
      currentRow += newValue.length;
    } else if (_$1.isNil(value)) {
      result.push('');
    } else {
      result.push(`B${currentRow}`);
      currentRow += 1;
    }

    return result;
  }, []).join(`${t}`);

  const globalStart = currentRow;
  const global = `A${globalStart}:B${_$1.size(rest) + globalStart - 1}`;

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$1d}(${parameters})`;
  }

  return `${namespace}${functionName$1d}(${parameters}, ${global})`;
}

function buildString$1d(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$1d}()`;
  }

  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;

  const segmentedValues = _$1.reduce({
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs
  }, (result, value, key) => {
    if (_$1.isString(value) && multiIncludes(value, protectedFunctions)) {
      result.push(value);
      return result;
    }

    if (arrayTypes$K.includes(key)) {
      const newValue = value ? value.split(',').join(';') : null;
      result.push(`{${newValue}}`);
      return result;
    }

    if (!_$1.isNil(value) || value === '') {
      result.push(`"${value}"`);
      return result;
    }

    result.push('');
    return result;
  }, []);

  let indicatorParams = segmentedValues.join(`${t}`);
  indicatorParams = _$1.trimEnd(indicatorParams, ',');

  if (_$1.isEmpty(rest)) {
    return `${namespace}${functionName$1d}(${indicatorParams})`;
  }

  const global = `${t}{${_$1.reduce(rest, function (result, val, key) {
    result.push(`"${key}"${t}"${val}"`);
    return result;
  }, []).join(`;`)}}`;
  return `${namespace}${functionName$1d}(${indicatorParams}${global})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$1d({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$1d,
    // R1C1: buildR1C1,
    A1: buildA1$1d
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

/* eslint-disable no-shadow */
const functionName$1e = 'METRICSMETADATA';

function buildA1$1e(namespace, t, value, firstColumn) {
  const startRow = 3;

  const parameters = _$1.reduce(Object.keys(value), function (result, value, index) {
    // Argument
    result.push(`A${index + startRow}`); // Value

    result.push(`B${index + startRow}`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$1e}()`;
  }

  return `${namespace}${functionName$1e}(${parameters})`;
}

function buildR1C1$8(namespace, t, value) {
  const {
    provider = '',
    endpoint = '',
    ...rest
  } = value;

  const parameters = _$1.reduce(Object.keys(rest), function (result, value, index) {
    // Argument
    result.push(`R[${index + 1}]C[-2]`); // Value

    result.push(`R[${index + 1}]C[-1]`);
    return result;
  }, []).join(`${t}`);

  if (_$1.isNil(rest) || _$1.isEmpty(rest)) {
    return `${namespace}${functionName$1e}(R[-1]C[-1],R[0]C[-1]`;
  }

  return `${namespace}${functionName$1e}(R[-1]C[-1],R[0]C[-1],${parameters}`;
}

function buildString$1e(namespace, t, value) {
  if (_$1.isNil(value) || _$1.isEmpty(value)) {
    return `${namespace}${functionName$1e}()`;
  }

  const parameters = _$1.reduce(value, function (result, val, key) {
    result.push(`"${key}"`);
    result.push(`"${val}"`);
    return result;
  }, []).join(`${t}`);

  return `${namespace}${functionName$1e}(${parameters})`;
}
/**
 *
 * @param {string} as "string", "R1C1", "A1"
 * @param {string} env "excel" or "sheets"
 * @param {string} listSeperator Comma (",") or Semi-colon (";")
 * @param {object} value Query or Body parameters
 */


function handler$1e({
  as = 'string',
  env = 'excel',
  listSeperator = ',',
  value = {}
}) {
  const namespaces = {
    excel: '=CS.',
    sheets: '=CS'
  };
  const namespace = namespaces[env];
  const firstColumn = 'A';
  const options = {
    string: buildString$1e,
    R1C1: buildR1C1$8,
    A1: buildA1$1e
  };
  return options[as](namespace, listSeperator, value, firstColumn);
}

var customFunctions = /*#__PURE__*/Object.freeze({
	__proto__: null,
	AD: handler,
	ADDRESS: handler$1,
	ADOSC: handler$2,
	ADX: handler$3,
	APO: handler$4,
	AROON: handler$5,
	AROONOSC: handler$6,
	ATH: handler$7,
	ATR: handler$8,
	BBANDS: handler$9,
	BETA: handler$a,
	CCI: handler$b,
	CDLINNECK: handler$c,
	CDLMARUBOZU: handler$d,
	CHAIN: handler$e,
	CLUSTERS: handler$f,
	CORREL: handler$g,
	DEMA: handler$h,
	DX: handler$i,
	EMA: handler$j,
	ENDPOINTS: handler$k,
	EXCHANGES: handler$l,
	EXP: handler$m,
	EXRATE: handler$n,
	FIELDS: handler$o,
	FLOOR: handler$p,
	IDEAS: handler$q,
	LINEARREG: handler$r,
	LINEARREG_ANGLE: handler$s,
	LINEARREG_INTERCEPT: handler$t,
	LINEARREG_SLOPE: handler$u,
	LN: handler$v,
	LOGIN: handler$w,
	MACD: handler$x,
	MACDEXT: handler$y,
	MACDFIX: handler$z,
	METRICS: handler$A,
	METRICSA: handler$B,
	MFI: handler$C,
	MOM: handler$D,
	NATR: handler$E,
	OBV: handler$F,
	OHLCV: handler$G,
	OHLCVA: handler$H,
	ORDERBOOKS: handler$I,
	ORDERBOOKSA: handler$J,
	ORDERBOOKSL3A: handler$K,
	PARAMETERS: handler$L,
	PRICE: handler$M,
	PRICEA: handler$N,
	PROVIDERS: handler$O,
	QUERY: handler$P,
	QUERYA: handler$Q,
	ROC: handler$R,
	ROCP: handler$S,
	ROCR: handler$T,
	RSI: handler$U,
	SAREXT: handler$V,
	SMA: handler$W,
	STATUS: handler$X,
	STOCH: handler$Y,
	SYMBOLS: handler$Z,
	T3: handler$_,
	TA: handler$$,
	TAHIS: handler$10,
	TAMETADATA: handler$11,
	TEMA: handler$12,
	TIME: handler$13,
	TRADES: handler$14,
	TRADESA: handler$15,
	TRANGE: handler$16,
	TRIX: handler$17,
	TSF: handler$18,
	ULTOSC: handler$19,
	VAR: handler$1a,
	WCLPRICE: handler$1b,
	WILLR: handler$1c,
	WMA: handler$1d,
	METRICSMETADATA: handler$1e
});

function getCustomFunction(customFunction, config) {
  if (_$1.has(customFunctions, customFunction)) {
    return customFunctions[customFunction](config);
  }

  return null;
}

function buildApi(config) {
  const {
    endpoint,
    value
  } = config;
  const {
    template,
    alias,
    parameters
  } = endpoint;
  const url = compileUrl({
    template,
    alias,
    parameters
  }, value);

  if (url.includes('stream.cryptosheets.com')) {
    return 'API not yet implemented';
  }

  return url;
}

function buildExcel(config) {
  const {
    as,
    customFunction,
    listSeperator,
    value
  } = config;
  const functionConfig = {
    env: 'excel',
    as,
    listSeperator,
    value
  }; // return customFunctions[customFunction](functionConfig);

  return getCustomFunction(customFunction, functionConfig);
}

function buildGoogleSheets(config) {
  const {
    as,
    customFunction,
    listSeperator,
    value
  } = config;
  const functionConfig = {
    env: 'sheets',
    as,
    listSeperator,
    value
  }; // return customFunctions[customFunction](functionConfig);

  return getCustomFunction(customFunction, functionConfig);
}

function buildSample(type, config) {
  const options = {
    web: buildApi,
    excel: buildExcel,
    sheets: buildGoogleSheets
  };
  return options[type](config);
}

const protectedFunctions$1 = ['OHLCV', 'OHLCVA'];
function multiIncludes$1(text, values) {
  const re = new RegExp(values.join('|'));
  return re.test(text);
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$1(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$1(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['ADDRESS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$2(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$1(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$1(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$2(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$3(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$2(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$2(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$3(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$4(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$3(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$3(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$4(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    optInMAType,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$5(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$4(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$4(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$5(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$6(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$5(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$5(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$6(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$7(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$6(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$6(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$7(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['ATH'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$8(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$7(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$7(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$8(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$9(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$8(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$8(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$9(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInNbDevUp,
    optInNbDevDn,
    optInMAType,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$a(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$9(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$9(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$a(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal0,
    inReal1,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$b(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$a(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$a(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$b(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$c(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$b(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$b(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$c(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    open,
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$d(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$c(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$c(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$d(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    open,
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$e(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$d(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$d(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$e(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['CHAIN'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$f(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$e(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$e(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$f(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['CLUSTERS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$g(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$f(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$f(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$g(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal0,
    inReal1,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$h(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$g(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$g(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$h(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$i(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$h(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$h(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$i(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$j(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$i(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$i(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$j(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$k(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$j(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$j(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$k(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['ENDPOINTS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$l(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$k(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$k(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$l(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['EXCHANGES'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$m(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$l(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$l(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$m(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$n(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$m(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$m(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$n(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['EXRATE'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$o(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$n(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$n(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$o(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['FIELDS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$p(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$o(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$o(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$p(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$q(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$p(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$p(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$q(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['IDEAS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$r(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$q(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$q(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$r(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$s(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$r(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$r(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$s(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$t(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$s(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$s(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$t(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$u(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$t(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$t(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$u(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$v(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$u(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$u(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$v(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$w(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$v(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$v(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$w(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInSlowPeriod,
    optInSignalPeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$x(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$w(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$w(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$x(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInFastPeriod,
    optInFastMAType,
    optInSlowPeriod,
    optInSlowMAType,
    optInSignalPeriod,
    optInSignalMAType,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$y(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$x(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$x(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$y(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInSignalPeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$z(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$y(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$y(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$z(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['METRICS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$A(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$z(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$z(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$A(resource, value) {
  const data = [];
  Object.keys(value).forEach((key, index) => {
    if (index === 0) {
      data.push([key, value[key], '=FORMULATEXT(C4)']);
    } else {
      data.push([key, value[key], '']);
    }
  });
  return {
    title: ['METRICSA'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$B(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$A(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$A(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$B(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    volume,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$C(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$B(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$B(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$C(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$D(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$C(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$C(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$D(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$E(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$D(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$D(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$E(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    volume,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$F(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$E(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$E(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$F(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['OHLCV'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$G(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$F(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$F(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$G(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['OHLCVA'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$H(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$G(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$G(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$H(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['ORDERBOOKS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$I(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$H(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$H(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$I(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['ORDERBOOKSA'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$J(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$I(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$I(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$J(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['ORDERBOOKSL3A'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$K(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$J(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$J(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$K(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['PARAMETERS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$L(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$K(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$K(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$L(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['PRICE'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$M(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$L(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$L(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$M(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['PRICEA'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$N(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$M(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$M(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$N(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['PROVIDERS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$O(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$N(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$N(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$O(resource, value) {
  const data = [];
  const {
    provider,
    endpoint,
    ...rest
  } = value;
  data.push(['provider', provider, '=FORMULATEXT(C4)']);
  data.push(['endpoint', endpoint, '']);

  if (!_$1.isEmpty(rest)) {
    Object.keys(rest).forEach((key, index) => {
      data.push([key, value[key], '']);
    });
  }

  return {
    title: ['QUERY'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$P(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$O(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$O(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$P(resource, value) {
  const data = [];
  const {
    provider,
    endpoint,
    ...rest
  } = value;
  data.push(['provider', provider, '=FORMULATEXT(C4)']);
  data.push(['endpoint', endpoint, '']);

  if (!_$1.isEmpty(rest)) {
    Object.keys(rest).forEach((key, index) => {
      data.push([key, value[key], '']);
    });
  }

  return {
    title: ['QUERYA'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$Q(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$P(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$P(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$Q(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$R(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$Q(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$Q(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$R(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$S(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$R(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$R(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$S(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$T(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$S(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$S(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$T(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$U(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$T(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$T(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$U(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    startIdx,
    endIdx,
    optInStartValue,
    optInOffsetOnReverse,
    optInAccelerationInitLong,
    optInAccelerationLong,
    optInAccelerationMaxLong,
    optInAccelerationInitShort,
    optInAccelerationShort,
    optInAccelerationMaxShort,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$V(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$U(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$U(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$V(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$W(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$V(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$V(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$W(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['STATUS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$X(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$W(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$W(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$X(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInFastK_Period,
    optInSlowK_Period,
    optInSlowK_MAType,
    optInSlowD_Period,
    optInSlowD_MAType,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$Y(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$X(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$X(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$Y(resource, value) {
  const data = [];

  if (_$1.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['SYMBOLS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$Z(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$Y(resource, value);
    console.log(data);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$Y(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$Z(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInVFactor,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$_(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$Z(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$Z(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$_(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['TA'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$$(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$_(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$_(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$$(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['TAHIS'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$10(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$$(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$$(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$10(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['TAMETADATA'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$11(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$10(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$10(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$11(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$12(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$11(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$11(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$12(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['TIME'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$13(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$12(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$12(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$13(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['TRADES'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$14(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$13(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$13(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$14(resource, value) {
  const data = [];

  if (_.isEmpty(value)) {
    data.push(['', '', '=FORMULATEXT(C4)']);
  } else {
    Object.keys(value).forEach((key, index) => {
      if (index === 0) {
        data.push([key, value[key], '=FORMULATEXT(C4)']);
      } else {
        data.push([key, value[key], '']);
      }
    });
  }

  return {
    title: ['TRADESA'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$15(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$14(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$14(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$15(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$16(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$15(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$15(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$16(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$17(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$16(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$16(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$17(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$18(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$17(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$17(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$18(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod1,
    optInTimePeriod2,
    optInTimePeriod3,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$19(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$18(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$18(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$19(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    optInNbDev,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$1a(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$19(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$19(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$1a(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$1b(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$1a(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$1a(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$1b(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    high,
    low,
    close,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$1c(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$1b(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$1b(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

// $('#create-report').click(() => tryCatch(createReport));

function buildData$1c(resource, value) {
  const arrayTypes = ['high', 'low', 'close', 'volume', 'inReal', 'inReal0', 'inReal1', 'open'];
  const {
    inReal,
    startIdx,
    endIdx,
    optInTimePeriod,
    globalArgs,
    ...rest
  } = value;
  const data = [];

  const parameters = _$1.omit(value, Object.keys(rest));

  Object.keys(parameters).forEach((key, index) => {
    if (index === 0) {
      data.push(['', '', '=FORMULATEXT(C4)']);
    }

    if (_$1.isString(value[key]) && multiIncludes$1(value[key], protectedFunctions$1)) {
      data.push([key, 'Parameter added as string to custom function.', '']);
    } else if (arrayTypes.includes(key)) {
      // Must push values vertically
      const newValue = value[key].split(',');
      newValue.forEach((arrayValue, index) => {
        if (index === 0) {
          data.push([key, arrayValue, '']);
        } else {
          data.push(['', arrayValue, '']);
        }
      });
    } else {
      data.push([key, value[key], '']);
    }
  });
  Object.keys(rest).forEach((key, index) => {
    data.push([key, value[key], '']);
  });
  return {
    title: [`Template`],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$1d(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$1c(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$1c(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

function buildData$1d(resource, value) {
  const data = [];
  Object.keys(value).forEach((key, index) => {
    if (index === 0) {
      data.push([key, value[key], '=FORMULATEXT(C4)']);
    } else {
      data.push([key, value[key], '']);
    }
  });
  return {
    title: ['METRICSMETADATA'],
    headerNames: ['Parameters', 'Values', 'Formula'],
    data,
    resource
  };
}
/** Load sample data into a new worksheet and create a chart */


async function createReport$1e(host, config) {
  const {
    value
  } = config;

  if (host === 'excel') {
    const resource = buildSample('excel', { ...config,
      as: 'A1'
    });
    console.log(resource);
    const data = buildData$1d(resource, value);
    await createReport(data);
  }

  if (host === 'sheets') {
    const resource = buildSample('sheets', { ...config,
      as: 'A1'
    });
    const data = buildData$1d(resource, value);
    await addNewWorksheetWithData(data);
  }

  console.log('Success!', 'Report generation completed.');
}

var customFunctions$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	AD: createReport$1,
	ADDRESS: createReport$2,
	ADOSC: createReport$3,
	ADX: createReport$4,
	APO: createReport$5,
	AROON: createReport$6,
	AROONOSC: createReport$7,
	ATH: createReport$8,
	ATR: createReport$9,
	BBANDS: createReport$a,
	BETA: createReport$b,
	CCI: createReport$c,
	CDLINNECK: createReport$d,
	CDLMARUBOZU: createReport$e,
	CHAIN: createReport$f,
	CLUSTERS: createReport$g,
	CORREL: createReport$h,
	DEMA: createReport$i,
	DX: createReport$j,
	EMA: createReport$k,
	ENDPOINTS: createReport$l,
	EXCHANGES: createReport$m,
	EXP: createReport$n,
	EXRATE: createReport$o,
	FIELDS: createReport$p,
	FLOOR: createReport$q,
	IDEAS: createReport$r,
	LINEARREG: createReport$s,
	LINEARREG_ANGLE: createReport$t,
	LINEARREG_INTERCEPT: createReport$u,
	LINEARREG_SLOPE: createReport$v,
	LN: createReport$w,
	MACD: createReport$x,
	MACDEXT: createReport$y,
	MACDFIX: createReport$z,
	METRICS: createReport$A,
	METRICSA: createReport$B,
	MFI: createReport$C,
	MOM: createReport$D,
	NATR: createReport$E,
	OBV: createReport$F,
	OHLCV: createReport$G,
	OHLCVA: createReport$H,
	ORDERBOOKS: createReport$I,
	ORDERBOOKSA: createReport$J,
	ORDERBOOKSL3A: createReport$K,
	PARAMETERS: createReport$L,
	PRICE: createReport$M,
	PRICEA: createReport$N,
	PROVIDERS: createReport$O,
	QUERY: createReport$P,
	QUERYA: createReport$Q,
	ROC: createReport$R,
	ROCP: createReport$S,
	ROCR: createReport$T,
	RSI: createReport$U,
	SAREXT: createReport$V,
	SMA: createReport$W,
	STATUS: createReport$X,
	STOCH: createReport$Y,
	SYMBOLS: createReport$Z,
	T3: createReport$_,
	TA: createReport$$,
	TAHIS: createReport$10,
	TAMETADATA: createReport$11,
	TEMA: createReport$12,
	TIME: createReport$13,
	TRADES: createReport$14,
	TRADESA: createReport$15,
	TRANGE: createReport$16,
	TRIX: createReport$17,
	TSF: createReport$18,
	ULTOSC: createReport$19,
	VAR: createReport$1a,
	WCLPRICE: createReport$1b,
	WILLR: createReport$1c,
	WMA: createReport$1d,
	METRICSMETADATA: createReport$1e
});

function getCustomFunction$1(host, customFunction, config) {
  if (_$1.has(customFunctions$1, customFunction)) {
    return customFunctions$1[customFunction](host, config);
  }

  return null;
}

function generateGoogleSheetsTemplate({
  config
}) {
  const {
    customFunction
  } = config;
  return getCustomFunction$1('sheets', customFunction, config);
}

function generateExcelTemplate({
  config
}) {
  const {
    customFunction
  } = config;
  console.log(config);
  return getCustomFunction$1('excel', customFunction, config);
}
/**
 * Generate spreadsheet template from configuration options
 * @param {string} type Template to generate. "excel", "sheets"
 * @param {object} config Configuration object
 * @param {object} config.endpoint Endpoint object from table
 * @param {object} config.customFunction 'QUERYA', 'QUERY'
 * @param {object} config.listSeperator ',', ';'
 * @param {object} config.as 'string', 'R1C1', 'A1'
 * @param {object} config.value Parameter values
 */


async function generateTemplate({
  type,
  config
}) {
  try {
    const options = {
      excel: generateExcelTemplate,
      sheets: generateGoogleSheetsTemplate
    };
    await options[type]({
      config
    });
  } catch (e) {
    console.error('Error generating template: ', e);
  }
}

export { createReport as addNewWorksheetWithDataExcel, addNewWorksheetWithData as addNewWorksheetWithDataGoogle, arrayToObject, asyncBatchProcess, batchProcess, buildSample, buildSymbolId, checkIfEncrypted, compileUrl, copyCurrentWorksheet, createTree, decrypt, determineHost, dig, downloadExcelFromWeb, encrypt, ensureFile, errorHandler, execShellCommand, fetchUrlAndSanitizeParams, flattenObject, formatBytes, fromExcelDate, functionBuilder, generateStub, generateTemplate, getActiveCellAddress, getActiveCellValues, getActiveWorksheet, getCurrentFile, getFileAsPDF, getFileContents, getParametersByType, getTokenFromCustomFunction, getTokenViaDialog, getType, groupAndSanitizeParameters, insertSheets, isEmptyValues, jsonFlatten, jsonTo2dArray, jsonToCSV, jsonUnflatten, linkify, makeHttpGetRequest, newWorkbookFromEncodedString, nilOrDate, onSelectionChange, parseName as parseFullName, parseThenSendToSheet, parseJSONto2dArray as parseTo2dArray, pascalCase, registerSelectionChangedHandler, sanitizeMatrix, sanitizeParameters, selectRange, sendTokenToCustomFunction, sequenceArrayToObject, setData, setDataGoogle, sortingComparators, stripWorksheet, toExcelDate, tryCatch, unicornCase };
